<template>
    <div>
        <config-main-title v-if="false">
            Solicitação de Autorização
        </config-main-title>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Padrão..."
                            :optionsList="[
                                { id: 'DS', search: 'Data da Abertura' },
                                { id: 'NS', search: 'Solicitação' },
                                { id: 'PC', search: 'Paciente' },
                            ]"
                            optionsData="id"
                            v-model="filtros.tipo_ordem">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary" @click="filtros.ordem_dir = ( filtros.ordem_dir == 'A' ? 'D' : 'A' )" :disabled="!filtros.tipo_ordem">
                                        <i class="fa-solid fa-arrow-down-short-wide fa-fw" v-if="filtros.ordem_dir == 'A'"></i>
                                        <i class="fa-solid fa-arrow-down-wide-short fa-fw" v-else></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-credit-card"
                            type="select"
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            placeholder="Todas as Operadoras..."
                            v-model="filtros.id_operadora">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-filter"
                            placeholder="Todos os Status Ativos..."
                            type="select"
                            optionsMode="json"
                            :optionsList="lista_status_autorizacao"
                            optionsData="id"
                            v-model="filtros.status">
                        </az-input>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-calendar fa-fw"
                            placeholder="Data de Abertura"
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'E', search: 'Data de Envio' },
                                { id: 'V', search: 'Data de Validade' },
                                { id: 'A', search: 'Data de Atendimento' },
                                { id: 'G', search: 'Data de Agendamento' },
                                { id: 'X', search: 'Data de Autorização' },
                            ]"
                            optionsData="id"
                            v-model="filtros.ref_data">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search fa-fw"
                            type="text"
                            placeholder="Pesquisar por..."
                            v-model="filtros.pesquisar"
                            :iconEnd="{ color: 'outline-primary', icon: 'fa fa-plus', tooltip: 'Incluir.' }"
                            @clickButtonEnd="incluir()"
                            @onEnter="load(false)"
                            :shortkey="['ctrl', 'p']">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-pacientes" />
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="select"
                            :optionsList="lista_unidades"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-user-md fa-fw"
                            type="select"
                            placeholder="Todos os Médicos..."
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            optionsData="id_pessoa"
                            v-model="filtros.id_medico" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-play fa-fw"
                            placeholder="Todos..."
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'Atendidos' },
                                { id: 'N', search: 'Não Atendidos' },
                                { id: 'G', search: 'Agendados' },
                                { id: 'X', search: 'Não Agendados' },
                            ]"
                            optionsData="id"
                            v-model="filtros.filtro_atend">
                        </az-input>                   
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            v-if="filtros.op_filtro == 'PAC'"
                            placeholder="Selecionar paciente..."
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtros.paciente"
                            :optimized_ac="true">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-user fa-fw" v-if="filtros.op_filtro == 'PAC'"></i>
                                        <i class="fa-solid fa-house-signal fa-fw" v-if="filtros.op_filtro == 'APOIO'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'APOIO'">
                                            <i class="fa-solid fa-house-signal fa-fw mr-2"></i>
                                            Apoiado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUS'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Fluxo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUSR'">
                                            <i class="fa-solid fa-filter-list fa-fw mr-2"></i>
                                            Status Registrado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PEND'">
                                            <i class="fa-solid fa-circle-check fa-fw mr-2"></i>
                                            Pendência
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="exibicao && exibicao.length" title="Quantidade">
                                    <span class="input-group-text">{{ exibicao.length }}</span>
                                </div>

                                <div class="input-group-append" v-if="filtros.paciente">
                                    <button type="button" class="btn btn-outline-primary" v-if="filtros.paciente.id_pessoa > 0" 
                                        @click="$root.perfil(filtros.paciente)" title="Paciente">
                                        <i class="fa-solid fa-id-badge"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-secondary" v-if="filtros.paciente.id_pessoa < 0" 
                                        @click="$root.perfil_temp(filtros.paciente)" title="Paciente">
                                        <i class="fa-solid fa-id-badge"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'APOIO'"
                            placeholder="Apoiado..."
                            type="autocomplete"
                            service="apoiados.index"
                            optionsMode="aql"
                            optionsName="apoiados.index"
                            v-model="filtros.apoiado">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-user fa-fw" v-if="filtros.op_filtro == 'PAC'"></i>
                                        <i class="fa-solid fa-house-signal fa-fw" v-if="filtros.op_filtro == 'APOIO'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'APOIO'">
                                            <i class="fa-solid fa-house-signal fa-fw mr-2"></i>
                                            Apoiado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUS'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Fluxo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUSR'">
                                            <i class="fa-solid fa-filter-list fa-fw mr-2"></i>
                                            Status Registrado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PEND'">
                                            <i class="fa-solid fa-circle-check fa-fw mr-2"></i>
                                            Pendência
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="exibicao && exibicao.length" title="Quantidade">
                                    <span class="input-group-text">{{ exibicao.length }}</span>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'STATUS' || filtros.op_filtro == 'STATUSR' || filtros.op_filtro == 'PEND'"
                            placeholder="Status..."
                            type="select"
                            service="contato_status.index"
                            :optionsParm="{ 
                                lista: true,
                                model: 'solicitacaoAutorizacao',
                                ativos: true
                            }"
                            optionsMode="aql"
                            optionsName="contato_status.index.aut"
                            optionsData="id_contato_status"
                            v-model="filtros.id_contato_status">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-filter fa-fw" v-if="filtros.op_filtro == 'STATUS'"></i>
                                        <i class="fa-solid fa-filter-list fa-fw" v-else-if="filtros.op_filtro == 'STATUSR'"></i>
                                        <i class="fa-solid fa-circle-check fa-fw" v-else-if="filtros.op_filtro == 'PEND'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'APOIO'">
                                            <i class="fa-solid fa-house-signal fa-fw mr-2"></i>
                                            Apoiado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUS'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Fluxo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STATUSR'">
                                            <i class="fa-solid fa-filter-list fa-fw mr-2"></i>
                                            Status Registrado
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PEND'">
                                            <i class="fa-solid fa-circle-check fa-fw mr-2"></i>
                                            Pendência
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="exibicao && exibicao.length" title="Quantidade">
                                    <span class="input-group-text">{{ exibicao.length }}</span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-3">
                        <az-input
                            icon="fa fa-filter fa-fw"
                            type="select"
                            placeholder="Sem filtro por fila de autorização..."
                            optionsMode="aql"
                            service="fila_autorizacoes.index"
                            :optionsName="'fila.aut.' + $store.state.user.id_usuario"
                            optionsData="id_fila_autorizacao"
                            v-model="filtros.id_fila_autorizacao" />
                    </div>
                    <div class="col col-3">
                        <az-input
                            label="Incluir autorizações da recepção"
                            type="checkbox-group"
                            v-model="filtros.recepcao" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            :icon="ja_buscou ? '' : 'fa-solid fa-magnifying-glass'"
            :msg="ja_buscou ? '' : 'Buscar'"
            action="Buscar"
            :method="load"
            v-if="!exibicao || !exibicao.length" />

        <template v-else>
            <div v-if="options_classes && options_classes.length" class="mb-2">
                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in options_classes" :key="icx">
                    <span class="badge badge-success mr-1">
                        {{ classe }}
                    </span>
                </a>
            </div>

            <div id="lista-pacientes">

                <cabecalho-generico titulo="Autorizações">
                </cabecalho-generico>

                <div class="card mb-2 dashcard" v-for="(solic, isx) in exibicao" :key="isx">
                    <div class="card-body p-1 px-2">
                        <div class="row">
                            <!-- Ação -->
                            <div class="col col-12 col-md-2 d-flex flex-column justify-content-start">
                                <span class="badge mb-1" v-if="solic.status_contato" :class="'badge-' + solic.status_contato.contato_status.st_color">
                                    {{ solic.status_contato.contato_status.search }}
                                </span>
                                <div v-if="solic.status_solicitacao.msg != 'Cancelado' || 1 == 1 ">
                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="editar(solic)"
                                        data-toggle="tooltip" data-placement="top" title="Editar Solicitação de Autorização">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm mr-1" :class="solic.credenciais ? ( solic.credenciais.fl_invalido ? 'btn-danger' : 'btn-primary' ) : 'btn-outline-primary'" v-if="solic.contrato_operadora && solic.contrato_operadora.fl_reembolso" @click="obter_credenciais_reembolso(solic)"
                                        data-toggle="tooltip" data-placement="top" title="Obter Credenciais">
                                        <i class="fas fa-key"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-dark mr-1" @click="marcar_enviada(solic)"
                                        v-if="!solic.marcacao || !solic.marcacao.id_atendimento" data-toggle="tooltip" data-placement="top" title="Marcar como enviada">
                                        <i class="fas fa-paper-plane"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="imprimir(solic)"
                                        data-toggle="tooltip" data-placement="top" :title="solic.fl_apac ? 'Imprimir LEA' : 'Imprimir Solicitação'">
                                        <i class="fas fa-print"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="assinar_lea(solic)"
                                        v-if="solic.fl_apac"
                                        data-toggle="tooltip" data-placement="top" title="Assinar LEA">
                                        <i class="fas fa-signature"></i>
                                    </button>
                                    <template v-if="1==1 || solic.dt_envio || ( solic.marcacao && solic.marcacao.id_atendimento ) || ( solic.procedimento && solic.procedimento.id_especialidade == 2 )">
                                        <button type="button" class="btn btn-sm btn-outline-info mr-1" @click="autorizar(solic)"
                                            data-toggle="tooltip" data-placement="top" title="Registrar Autorização">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                    </template>

                                    <template v-if="tem_autorizador(solic)">
                                        <span class="dropdown">
                                            <button class="btn btn-sm btn-outline-info mr-1"
                                                :class="( solic.status_solicitacao && solic.status_solicitacao.color ) ? 'text-' + solic.status_solicitacao.color : 'text-secondary'"
                                                type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i data-toggle="tooltip" data-placement="top" title="Autorização Online">
                                                    <i class="fas fa-wifi"></i>
                                                </i>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <div class="dropdown-item text-muted" v-if="solic && solic.status_solicitacao">
                                                    <span class="badge" :class="'badge-' + solic.status_solicitacao.color">
                                                    {{ solic.status_solicitacao.msg }}
                                                    </span>
                                                </div>
                                                <a class="dropdown-item" href="#" @click.prevent="autorizar_online(solic)">{{ solic ? 'Re-enviar Autorização' : 'Autorizar Online' }}</a>
                                                <div class="dropdown-divider" v-if="solic"></div>
                                                <a class="dropdown-item" v-if="solic" href="#" @click.prevent="consultar_online(solic)">Status</a>
                                                <a class="dropdown-item" v-if="solic" href="#" @click.prevent="cancelar_online(solic)">Cancelamento</a>
                                                <a class="dropdown-item" v-if="solic" href="#" @click.prevent="enviar_documentos(solic)">Enviar Documentos/Anexos</a>
                                                <a class="dropdown-item" href="#" @click.prevent="log_comunicacao(solic)" v-if="solic && $store.state.user.id_usuario == 1">Log</a>
                                            </div>
                                        </span>
                                        <!-- <button type="button" class="btn btn-sm btn-success mr-1"
                                        @click="autorizar_online(solic)" v-if="(solic.in_status == 0 || solic.in_status == 3) && tem_autorizador(solic)"
                                            data-toggle="tooltip" data-placement="top" title="Registrar Autorização Online">
                                            <i class="fa fa-wifi" aria-hidden="true"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-warning mr-1"
                                            @click="consultar_online(solic)" v-if="solic.plano.operadora.fl_servico_autorizacao && (solic.in_status == 2)"
                                            data-toggle="tooltip" data-placement="top" title="Consultar Autorização Online">
                                            <i class="fa fa-wifi" aria-hidden="true"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-success mr-1"
                                            @click="cancelar_online(solic)" v-if="solic.plano.operadora.fl_servico_autorizacao && (solic.in_status == 1)"
                                            data-toggle="tooltip" data-placement="top" title="Cancelar Autorização Online">
                                            <i class="fa fa-wifi" aria-hidden="true"></i>
                                        </button> -->
                                    </template>

                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="editar_contatos(solic)" data-toggle="tooltip" data-placement="top" title="Editar Ocorrências">
                                        <i class="fa-solid fa-comment"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-outline-success mr-1" @click="agendar(solic)"
                                        data-toggle="tooltip" data-placement="top" title="Agendar Procedimento" v-if="!solic.marcacao || solic.procedimento.id_classe_procedimento == 17 || solic.fl_apac">
                                        <i class="far fa-calendar-plus"></i>
                                    </button>

                                    <a href="#" @click.prevent="ver_sessoes(solic)">
                                        <span class="badge badge-secondary" title="Marcações">
                                            {{ solic.marcacoes.length }}
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <!-- Data -->
                            <div class="col col-12 col-md-2 d-flex flex-column justify-content-start">
                                <span class="badge" :class="'badge-' + solic.status_solicitacao.color" v-if="solic && solic.status_solicitacao">
                                    {{ solic.status_solicitacao.msg }}
                                    <i class="fa fa-check fa-fw ml-2" aria-hidden="true" v-if="solic && solic.marcacao && solic.marcacao.id_atendimento"></i>
                                </span>
                                <div>
                                    <span class="mr-2">
                                        <i class="fa-solid fa-circle-exclamation text-success" aria-hidden="true" title="Avulso" v-if="solic.fl_avulso"></i>
                                        <i class="fa fa-plus-circle text-primary" aria-hidden="true" title="Solicitação" v-else></i>
                                        {{ $util.getFormatDate(solic.dt_solicitacao) }}
                                    </span>

                                    <span class="text-muted text-nowrap">
                                        <i class="fa-solid fa-stamp"></i>
                                        {{ solic.id_solicitacao_autorizacao }}
                                    </span>
                                </div>
                                <div v-if="solic.marcacao && solic.marcacao.st_id_externo && solic.marcacao.st_id_externo.length > 1" class="small text-muted">
                                    {{ solic.marcacao.st_id_externo }}
                                </div>
                            </div>

                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-3">
                                <celula-dados-paciente 
                                    :callback_paciente="filtrar" 
                                    :hor="{ marcacao: solic }"
                                    :anexos="true"
                                    @abriranexos="abrir_anexar_arquivo" />
                            </div>

                            <!-- Identificação do Procedimento -->
                            <div class="col col-12 col-md-3">
                                <celula-dados-procedimento
                                    :truncate="false"
                                    :hor="{ marcacao: { ...solic, st_observacoes: solic.marcacao ? solic.marcacao.st_observacoes : '' } }"
                                    @abriranexos="abrir_anexar_arquivo" />
                                <div v-if="solic.apoiado" class="text-muted small">
                                    {{ solic.apoiado.search }}
                                </div>
                            </div>

                            <!-- Outras Informações -->
                            <div class="col col-12 col-md-2 d-flex justify-content-between">
                                <div>
                                    <div v-if="solic.dt_envio">
                                        <i class="fas fa-paper-plane fa-fw mr-1" tooltip="Data de Envio."></i>
                                        {{ $util.getFormatDate(solic.dt_envio) }}
                                    </div>
                                    <div v-if="!solic.st_codigo_autorizacao && solic.in_diarias">
                                        <i class="fa-solid fa-bed fa-fw mr-1"></i>
                                        {{ solic.in_diarias }} {{ solic.in_diarias > 1 ? 'Diárias' : 'Diária' }}
                                    </div>
                                    <div v-if="solic.st_codigo_autorizacao">
                                        <i class="fa fa-hashtag fa-fw mr-1" aria-hidden="true" tooltip="Código da Autorização."></i>
                                        {{ solic.st_codigo_autorizacao }}
                                        <span class="badge badge-secondary ml-1" v-if="solic.in_diarias" title="Diárias">{{ solic.in_diarias }}D</span>
                                    </div>
                                    <div v-if="solic.st_codigo_autorizacao">
                                        <i class="fas fa-hourglass-end fa-fw mr-1" tooltip="Validade da Autorização."></i>
                                        {{ $util.getFormatDate(solic.dt_valid_termino) }}
                                        <span v-if="solic.condicao_validade" class="badge" :class="'badge-' + solic.condicao_validade.color">
                                            {{ solic.condicao_validade.msg }}
                                        </span>
                                    </div>
                                    <div v-if="solic.marcacao">
                                        <celula-horarios-marcacao :hor="{ marcacao: solic.marcacao }" :onlyPanel="true" v-if="solic.marcacao" @refresh="load()">
                                            <template v-slot:info>
                                                <i class="fa fa-calendar-check-o fa-fw mr-1" aria-hidden="true" v-if="false && !solic.marcacao.id_atendimento" tooltip="Data para a qual o paciente está agendado."></i>
                                                <span class="ml-1">
                                                    <a href="#" v-if="!solic.marcacao.id_atendimento" class="card-link" @click.prevent="abrir_recepcao(solic)">
                                                        {{ $util.getFormatDate(solic.marcacao.dt_inicio) }}
                                                    </a>
                                                    <span v-else>
                                                        {{ $util.getFormatDate(solic.marcacao.dt_inicio) }}
                                                    </span>
                                                </span>

                                                <span v-if="solic.marcacao && solic.marcacao.doc_pre_atends_count" title="Pré-Atendimento registrado">
                                                    <i class="fa-solid fa-file-pen fa-fw ml-2"></i>
                                                </span>

                                                <a href="#" @click.prevent="abrir_anexar_arquivo(solic.marcacao, solic.marcacao.id_marcacao, 'marcacao')"
                                                    class="card-link ml-1" v-if="solic.marcacao.arquivos" 
                                                    :title="solic.marcacao.arquivos.length + ( solic.marcacao.arquivos.length  == 1 ? ' arquivo anexado ao atendimento' : ' arquivos anexados ao atendimento' )">
                                                    <i class="fas fa-paperclip" v-if="solic.marcacao.arquivos.length"></i>
                                                    <i class="fa fa-plus" v-else aria-hidden="true"></i>
                                                </a>

                                                <div v-if="solic.marcacao.id_atendimento">
                                                    <a href="#" v-if="solic.marcacao.id_atendimento" class="card-link" @click.prevent="abrir_atendimento(solic)">
                                                        <i class="fa fa-check fa-fw ml-2" aria-hidden="true" :title="'Atendimento: #' + solic.marcacao.id_atendimento"></i>
                                                    </a>
                                                </div>
                                                
                                            </template>
                                        </celula-horarios-marcacao>
                                    </div>
                                    <div v-if="solic.marcacao_futura && ( !solic.marcacao || solic.marcacao_futura.id_marcacao != solic.marcacao.id_marcacao )" title="Marcação mais recente do paciente.">
                                        <i class="far fa-calendar fa-fw mr-1"></i>
                                        {{ $util.getFormatDate(solic.marcacao_futura.dt_inicio) }}
                                    </div>
                                </div>
                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <template>
                                            <button class="dropdown-item" @click="novoDocumento(solic.marcacao, solic)">
                                                <i class="fa-regular fa-file-lines fa-fw mr-2"></i>
                                                Emitir Documento
                                            </button>
                                        </template>

                                        <button class="dropdown-item" @click="log_autorizacoes(solic)" v-if="$store.state.user.id_usuario == 1">
                                            <i class="fas fa-clipboard-list fa-fw mr-2"></i>
                                            Log das autorizaçōes online
                                        </button>

                                        <button class="dropdown-item" @click="$refs.alterar_proc.abrir(solic)"
                                            :disabled="!solic.fl_apac && solic.marcacao && ( solic.marcacao.atendimento || solic.marcacao.ch_estado_marcacao != 'A' )">
                                            <i class="fas fa-exchange-alt fa-fw mr-2"></i>
                                            Alterar Procedimento
                                        </button>

                                        <button class="dropdown-item" @click="alterar_solicitante(solic)">
                                            <i class="fas fa-exchange-alt fa-fw mr-2"></i>
                                            Alterar Profissional Solicitante
                                        </button>

                                        <button class="dropdown-item" @click="executar_agora(solic)"
                                            v-if="!solic.marcacao && solic.id_requisicao_procedimento && ( ( solic.created_at && solic.created_at.substr(0,10) == $util.hoje() ) || ( solic.procedimento && solic.procedimento.id_classe_procedimento == 20 ) )">
                                            <i class="fa fa-play fa-fw mr-2" aria-hidden="true"></i>
                                            Executar Agora
                                        </button>

                                        <button class="dropdown-item" @click="$refs.formpre.abrir(solic.marcacao, solic)"
                                            v-if="solic.marcacao && solic.marcacao.ch_estado_marcacao == 'A'">
                                            <i class="fas fa-file-export fa-fw mr-2"></i>
                                            Formulário de Pré-Atendimento
                                        </button>

                                        <button
                                            class="dropdown-item"
                                            @click="$refs.doc_pre_atend.abrir(solic.marcacao)"
                                            :disabled="!solic.marcacao">
                                            <i class="fa-solid fa-file-pen fa-fw mr-2"></i>
                                            Pré-Atendimento
                                            <span class="badge badge-secondary" v-if="solic.marcacao && ( solic.marcacao.doc_pre_atends_count || ( solic.marcacao.doc_pre_atends && solic.marcacao.doc_pre_atends.length ) )">
                                                {{ solic.marcacao.doc_pre_atends_count ? solic.marcacao.doc_pre_atends_count : solic.marcacao.doc_pre_atends.length }}
                                            </span>
                                        </button>

                                        <button class="dropdown-item" @click="gerar_orcamento(solic)" v-if="solic.in_status_geral == 4 || solic.in_status_geral == 3 || solic.in_status_geral == 7">
                                            <i class="fa-solid fa-dollar-sign fa-fw mr-2"></i>
                                            Gerar Orçamento dos Itens Negados
                                        </button>

                                        <button class="dropdown-item" @click="gerar_orcamento(solic)" v-else-if="solic.plano && solic.plano.id_operadora == 1">
                                            <i class="fa-solid fa-dollar-sign fa-fw mr-2"></i>
                                            Gerar Orçamento
                                        </button>

                                        <template v-if="solic.marcacao && solic.marcacao.st_id_externo && solic.marcacao.st_id_externo.indexOf(':') > 0">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="integrar_solic_klingo(solic)">
                                                <i class="fa-solid fa-tower-cell fa-fw mr-2"></i>
                                                Integrar Solicitação de Autorização
                                            </button>
                                        </template>

                                        <!--
                                        <button class="dropdown-item" @click="log_autorizacoes(solic)" v-if="!solic.marcacao">
                                            <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                            Alterar Profissional
                                        </button>
                                        -->

                                        <laboratorio-etiqueta v-model="solic.marcacao" :dropdown="true">
                                            <template v-slot:dropamostras>
                                                <button class="dropdown-item" v-if="solic.marcacao && solic.marcacao.atendimento && solic.marcacao.atendimento.amostras_count"
                                                    @click="$refs.amostras.abrir(solic.marcacao.id_atendimento)">
                                                    <i class="fas fa-vials fa-fw mr-2"></i>
                                                    Amostras
                                                </button>
                                            </template>
                                        </laboratorio-etiqueta>

                                        <div class="dropdown-divider" v-if="solic"></div>
                                        <button class="dropdown-item" @click="clonar(solic)">
                                            <i class="fa-solid fa-clone fa-fw mr-2"></i>
                                            Clonar Solicitação
                                        </button>

                                        <template v-if="!solic.id_paciente && solic.id_cadastro_temporario">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="cadastrar_paciente(solic)" >
                                                <i class="fa-solid fa-person-circle-plus fa-fw mr-2"></i>
                                                Cadastrar Paciente
                                            </button>
                                        </template>

                                        <button class="dropdown-item" @click="adicionar_marcacao(solic.marcacao)" v-if="solic.marcacao && solic.marcacao.id_marcacao">
                                            <i class="fa-regular fa-calendar-plus fa-fw mr-2"></i>
                                            Realizar Outra Marcação
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="solic.paciente && solic.paciente.atendimento_pacotes && solic.paciente.atendimento_pacotes.length">
                            <div class="col col-12">
                                <historico-pacotes-paciente 
                                    :autoriz="true"
                                    :lista="solic.paciente.atendimento_pacotes" 
                                    :ativos="true"
                                    :reduzido="true"
                                    :pode_fechar="true"
                                    :id_atendimento="( solic.marcacoes && solic.marcacoes[0] && solic.marcacoes[0].id_atendimento ) ? solic.marcacoes[0].id_atendimento : null" />
                            </div>
                        </div>
                    </div>
                    <div class="card-footer py-1 px-2" v-if="solic.js_classes && solic.js_classes.length">
                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in solic.js_classes" :key="icx">
                            <span class="badge badge-success mr-1">
                                {{ classe }}
                            </span>
                        </a>
                    </div>
                </div>

            </div>
        </template>

        <!-- Modal -->
        <div class="modal fade" id="novaSolicitacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Nova Solicitação de Autorização</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <nova-solicitacao-autorizacao ref="novasolic" @refresh="load()" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="autorizarModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total" v-if="modal_tipo == 'autorizar'">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Autorização
                            <template v-if="item">
                                <span class="badge badge-secondary ml-2">
                                    #{{ item.id_solicitacao_autorizacao }}
                                </span>
                                <span v-if="valor_total_previa" class="ml-3">
                                    <span class="badge badge-secondary">
                                        {{ item.js_secundarios.length + 1 }}
                                    </span>
                                    R$ {{ $util.formatMoeda(valor_total_previa) }}
                                </span>
                                <span v-if="item.nome_paciente" class="ml-3">
                                    {{ item.nome_paciente }}
                                </span>

                                <span class="badge badge-primary ml-3" v-if="item.in_diarias" title="Diárias">
                                    <i class="fa-solid fa-bed mr-1"></i>
                                    {{ item.in_diarias }}
                                </span>
                            </template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="!item">
                            <az-empty-state />
                        </template>

                        <template v-else>

                            <div v-if="item.marcacao && item.marcacao.infusao" class="mb-3">
                                {{ item.marcacao.infusao.st_titulo }}
                            </div>

                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        :label="item.fl_apac ? 'CNS' : 'Número da Matrícula'"
                                        :validate="validate"
                                        v-model="item.numero_carteira">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                    @click="copiar_clipboard(item.numero_carteira)">
                                                    <i class="fas fa-copy"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12" :class="item.info_diarias ? 'col-md-3' : 'col-md-4'" v-if="!item.fl_apac">
                                    <az-input
                                        sizing="sm"
                                        label="Número da guia na operadora"
                                        :validate="validate"
                                        :edicao2="item.in_status == 0"
                                        v-model="item.st_guia_operadora" />
                                </div>
                                <div class="col col-12" :class="item.info_diarias ? 'col-md-3' : 'col-md-4'" v-if="!item.fl_apac">
                                    <az-input
                                        sizing="sm"
                                        label="Número da guia do prestador"
                                        placeholder="Padrão"
                                        :validate="validate"
                                        v-model="item.st_guia_prestador" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="item.info_diarias">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Diárias"
                                        :validate="validate"
                                        placeholder="Não informado..."
                                        v-model="item.in_diarias" />
                                </div>
                            </div>

                            <div class="form-row" :class="cor_linha(item)">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Procedimento"
                                        :edicao="false"
                                        v-model="item.procedimento.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append input-group-sm">
                                                <button type="button" class="btn btn-outline-primary" title="Incluir Membro da Equipe" v-if="$store.state.user.id_usuario == 1 && item.procedimento.id_classe_procedimento == 2" @click="incluir_membro_cirurgia()">
                                                    <i class="fa-solid fa-user-plus"></i>
                                                </button>

                                                <template>
                                                    <div class="dropdown">
                                                        <button class="btn btn-outline-secondary btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="item.in_quantidade > 0">
                                                            x{{ item.in_quantidade }}
                                                        </button>
                                                        <button class="btn btn-outline-secondary btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
                                                            x1
                                                        </button>
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item" href="#" @click.prevent="definir_qtde(item, idx)" v-for="idx in 12" :key="idx">x{{ idx }}</a>
                                                            <a class="dropdown-item" href="#" @click.prevent="editar_qtde(item)">Outra</a>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-if="1==0">
                                                    <div class="input-group-append input-group-sm">
                                                        <button class="btn px-1 btn-outline-secondary"
                                                            type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="fas fa-ellipsis-v"></i>
                                                        </button>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item" 
                                                                class2="( item.marcacao && ( !item.procedimento || item.procedimento.id_especialidade != 2 ) ) ? 'disabled' : ''" 
                                                                href="#" @click.prevent="remover_item(isx)">
                                                                Remover Item
                                                            </a>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-if="item.js_secundarios && item.js_secundarios.length"> <!-- item.st_codigo_autorizacao &&  -->
                                                    <button class="btn btn-outline-secondary px-1" type="button" data-toggle="tooltip" data-placement="top"
                                                        title="Copiar para os demais items." @click="copiar_senha(item)">
                                                        <i class="fas fa-arrows-alt-v"></i>
                                                    </button>
                                                </template>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        label="Status"
                                        type="select"
                                        :optionsList="lista_status_autorizacao"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        :validate="validate"
                                        v-model="item.in_status" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        :type="item.fl_apac ? 'apac' : 'text'"
                                        :label="item.fl_apac ? 'Número da APAC' : 'No. da Autorização / Senha'"
                                        required2="exigir_senha(item)"
                                        :validate="validate && ( item.in_status == 1 || item.in_status == 4 )"
                                        :edicao="item.in_status == 1 || item.in_status == 4"
                                        v-model="item.st_codigo_autorizacao">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.procedimento && item.procedimento.procedimento_pacotes && item.procedimento.procedimento_pacotes.length && !item.js_pacote">
                                                <button type="button" class="btn btn-outline-primary" 
                                                    @click="ver_pacotes(item.procedimento.procedimento_pacotes)">
                                                    <i class="fas fa-layer-group"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <template v-if="aut_view == 'val'">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Valor Unitário"
                                            :type="calc.troca ? 'number' : 'money'"
                                            :validate="validate"
                                            v-model="item.dc_valor_procedimento">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="calc.us == 1">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="calcular_valor_direto()">
                                                        <i class="fas fa-calculator"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Valor Total"
                                            :edicao="false"
                                            :value="$util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade)" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Valor com Fator"
                                            :edicao="false"
                                            :value="$util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade * ( item.dc_fator ? item.dc_fator : 1 ) )" />
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Data da Autorização"
                                            type="date"
                                            :required="item.in_status == 1 || item.in_status == 4"
                                            :validate="validate"
                                            v-model="item.dt_autorizacao" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Validade De..."
                                            type="date"
                                            :required="item.in_status == 1 || item.in_status == 4"
                                            :validate="validate"
                                            v-model="item.dt_valid_inicio" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Validade Até..."
                                            type="date"
                                            :required="item.in_status == 1 || item.in_status == 4"
                                            :validate="validate"
                                            v-model="item.dt_valid_termino" />
                                    </div>
                                </template>
                            </div>

                            <!-- Pacotes -->

                            <div v-if="item.js_pacote" class="form-row mb-2">
                                <div class="col col-12 col-md-8">
                                    <i class="fas fa-layer-group fa-fw mr-3 d-print-none"></i>
                                    <a href="#" @click.prevent="retirar_pacote(item)" class="text-danger d-print-none mr-2">
                                        <i class="fas fa-minus fa-fw"></i>
                                    </a>
                                    {{ item.js_pacote.search }}
                                </div>
                                <div class="col col-12 col-md-2">
                                    x{{ item.js_pacote.in_quantidade_items }}
                                </div>
                                <div class="col col-12 col-md-2" v-if="item.js_pacote.dc_valor_pacote">
                                    {{ $util.formatMoeda(item.js_pacote.dc_valor_pacote) }}
                                </div>
                            </div>

                            <div v-else-if="pacotes && indexProcPacote === null" class="form-row">
                                <div class="col col-12">
                                    <div class="list-group mb-2">
                                        <button type="button" class="list-group-item list-group-item-action"
                                            v-for="(pacote, index) in pacotes" :key="index" @click="selecionar_pacote(pacote)">
                                            <i class="fas fa-layer-group mr-2 text-primary"></i>
                                            {{ pacote.search }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Fim Pacote -->

                            <div v-if="item.js_equipe && item.js_equipe.equipe">
                                <aut-equipe-cirurgia 
                                    :value="item.js_equipe" 
                                    :graus="[
                                        { id_grau_participacao: '1', search: 'Primeiro Auxilio' }
                                    ]"
                                    :validate="validate" />
                            </div>

                            <div class="form-row" v-if="show_codes && item.procedimento" :class="cor_linha(item)">
                                <div class="col col-12 col-md-1">
                                    <span class="small text-muted">1</span>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        v-if="item.info_procedimentos[item.id_procedimento] && item.info_procedimentos[item.id_procedimento].st_codigo"
                                        sizing="sm"
                                        label="Código"
                                        :edicao="false"
                                        :compact="true"
                                        :value="item.info_procedimentos[item.id_procedimento].st_codigo">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                    @click="abrir_tabela(item.info_procedimentos[item.id_procedimento].id_item_tabela)">
                                                    <i class="fa-solid fa-magnifying-glass-dollar fa-fw"></i>
                                                </button>
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                    @click="copiar_clipboard(item.info_procedimentos[item.id_procedimento].st_codigo)">
                                                    <i class="fas fa-copy fa-fw"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>

                                    <az-input
                                        v-else
                                        sizing="sm"
                                        label="Código"
                                        :edicao="false"
                                        :compact="true">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!item.fl_apac">
                                                <span class="input-group-text" id="basic-addon2" title="Tabela não identificada.">
                                                    <i class="fa-solid fa-triangle-exclamation text-danger fa-fw"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="SUS"
                                        :edicao="false"
                                        :compact="true"
                                        :value="item.info_procedimentos[item.id_procedimento] ? item.info_procedimentos[item.id_procedimento].st_codigo_sus : item.procedimento.st_codigo_sus">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                    @click="copiar_clipboard(info_proc(item.id_procedimento) ? info_proc(item.id_procedimento).st_codigo_sus : item.procedimento.st_codigo_sus)">
                                                    <i class="fas fa-copy"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.info_procedimentos[item.id_procedimento] && item.info_procedimentos[item.id_procedimento].amostras && item.info_procedimentos[item.id_procedimento].amostras.length">
                                    <az-input
                                        v-if="item.info_procedimentos[item.id_procedimento].amostras.length == 1"
                                        label="Material"
                                        :compact="true"
                                        sizing="sm"
                                        :edicao="false"
                                        :value="item.info_procedimentos[item.id_procedimento].amostras[0].st_amostra_material" />

                                    <az-input
                                        v-else
                                        label="Material"
                                        :compact="true"
                                        sizing="sm"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="item.info_procedimentos[item.id_procedimento].amostras"
                                        optionsDisplay="st_amostra_material"
                                        optionsData="id_amostra_material"
                                        v-model="item.id_amostra_material" />
                                </div>
                            </div>

                            <template v-if="item.js_secundarios">
                                <div v-for="(secundario, isx) in item.js_secundarios" :key="isx">
                                    <div class="form-row" :class="cor_linha(secundario)">
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                :edicao="false"
                                                :value="secundario.st_procedimento ? secundario.st_procedimento : secundario.search">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append input-group-sm">
                                                        <template>
                                                            <div class="dropdown">
                                                                <button class="btn btn-outline-secondary btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="secundario.in_quantidade > 0">
                                                                    x{{ secundario.in_quantidade }}
                                                                </button>
                                                                <button class="btn btn-outline-secondary btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
                                                                    x1
                                                                </button>
                                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                    <a class="dropdown-item" href="#" @click.prevent="definir_qtde(secundario, idx)" v-for="idx in 12" :key="idx">x{{ idx }}</a>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <div class="input-group-append input-group-sm">
                                                        <button class="btn px-1 btn-outline-secondary"
                                                            type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="fas fa-ellipsis-v"></i>
                                                        </button>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <template v-if="secundario.in_status == 1 || secundario.in_status == 9 || secundario.in_status == 4">
                                                                <a class="dropdown-item" href="#" @click.prevent="definir_guia_sec(secundario)">
                                                                    {{ secundario.info_guia ? 'Mesma Guia' : 'Guia Separada' }}
                                                                </a>
                                                                <div class="dropdown-divider"></div>
                                                            </template>
                                                            <a class="dropdown-item" 
                                                                    class2="( item.marcacao && !item.fl_apac && ( !item.procedimento || item.procedimento.id_especialidade != 2 ) ) ? 'disabled' : ''" 
                                                                    href="#" 
                                                                    @click.prevent="remover_item(isx)">
                                                                Remover Item
                                                            </a>
                                                        </div>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-1">
                                            <az-input
                                                sizing="sm"
                                                :validate="validate"
                                                placeholder="Aguardando"
                                                type="select"
                                                :optionsList="[
                                                    { id: '0', search: 'Aberto' },
                                                    { id: '1', search: 'Autorizado' },
                                                    { id: '6', search: 'Enviado' },
                                                    { id: '9', search: 'On-line' },
                                                    { id: '2', search: 'Em Análise' },
                                                    { id: '3', search: 'Negado' },
                                                    { id: '4', search: 'Aut. Parcial' },
                                                    { id: '5', search: 'Cancelado' },
                                                    { id: '10', search: 'Em Sessão' },
                                                    { id: '11', search: 'Pendente' },
                                                    { id: '12', search: 'Particular' },
                                                ]"
                                                optionsData="id"
                                                v-model="secundario.in_status" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                sizing="sm"
                                                :type="item.fl_apac ? 'apac' : 'text'"
                                                :validate="validate && ( secundario.in_status == 1 || secundario.in_status == 4 )"
                                                required2="exigir_senha(secundario, item)"
                                                :edicao="secundario.in_status == 1 || secundario.in_status == 4"
                                                v-model="secundario.st_codigo_autorizacao">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="item.possiveis_pacotes 
                                                            && item.possiveis_pacotes.lista 
                                                            && item.possiveis_pacotes.lista[secundario.id_procedimento] 
                                                            && item.possiveis_pacotes.lista[secundario.id_procedimento].procedimento_pacotes 
                                                            && item.possiveis_pacotes.lista[secundario.id_procedimento].procedimento_pacotes.length
                                                            && !secundario.js_pacote">
                                                        <button type="button" class="btn btn-outline-primary" 
                                                            @click="ver_pacotes(item.possiveis_pacotes.lista[secundario.id_procedimento].procedimento_pacotes, isx)">
                                                            <i class="fas fa-layer-group"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <template v-if="aut_view == 'val'">
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    :type="calc.troca ? 'number' : 'money'"
                                                    :validate="validate"
                                                    v-model="secundario.dc_valor_procedimento">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="calc.us == 1">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="calcular_valor_direto(secundario)">
                                                                <i class="fas fa-calculator"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    :edicao="false"
                                                    :value="$util.formatMoeda(secundario.dc_valor_procedimento * secundario.in_quantidade)" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    :edicao="false"
                                                    :value="$util.formatMoeda(secundario.dc_valor_procedimento * secundario.in_quantidade * ( item.dc_fator ? item.dc_fator : 1 ) )" />
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    type="date"
                                                    :validate="validate"
                                                    v-model="secundario.dt_autorizacao" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    type="date"
                                                    :validate="validate"
                                                    v-model="secundario.dt_valid_inicio" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input
                                                    sizing="sm"
                                                    type="date"
                                                    :validate="validate"
                                                    v-model="secundario.dt_valid_termino" />
                                            </div>
                                        </template>
                                    </div>

                                    <!-- Pacotes (Secundários) -->

                                    <div v-if="secundario.js_pacote" class="form-row mb-2">
                                        <div class="col col-12 col-md-8">
                                            <i class="fas fa-layer-group fa-fw mr-3 d-print-none"></i>
                                            <a href="#" @click.prevent="retirar_pacote(secundario)" class="text-danger d-print-none mr-2">
                                                <i class="fas fa-minus fa-fw"></i>
                                            </a>
                                            {{ secundario.js_pacote.search }}
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            x{{ secundario.js_pacote.in_quantidade_items }}
                                        </div>
                                        <div class="col col-12 col-md-2" v-if="secundario.js_pacote.dc_valor_pacote">
                                            {{ $util.formatMoeda(secundario.js_pacote.dc_valor_pacote) }}
                                        </div>
                                    </div>

                                    <div v-else-if="pacotes && indexProcPacote === isx" class="form-row">
                                        <div class="col col-12">
                                            <div class="list-group mb-2">
                                                <button type="button" class="list-group-item list-group-item-action"
                                                    v-for="(pacote, index) in pacotes" :key="index" @click="selecionar_pacote(pacote)">
                                                    <i class="fas fa-layer-group mr-2 text-primary"></i>
                                                    {{ pacote.search }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Fim Pacote -->

                                    <div class="form-row" v-if="show_codes && item.procedimento && secundario" :key="'AM' + isx" :class="cor_linha(secundario)">
                                        <div class="col col-12 col-md-1">
                                            <span class="small text-muted">{{ isx + 2 }}</span>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                v-if="item.info_procedimentos[secundario.id_procedimento] && item.info_procedimentos[secundario.id_procedimento].st_codigo"
                                                sizing="sm"
                                                label="Código"
                                                :edicao="false"
                                                :compact="true"
                                                :value="item.info_procedimentos[secundario.id_procedimento].st_codigo">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2" v-if="item.info_procedimentos[secundario.id_procedimento].nao_cobre">
                                                            <i class="fa fa-ban text-danger fa-fw" aria-hidden="true" :title="'Não cobre: ' + item.info_procedimentos[secundario.id_procedimento].restricao_titulo"></i>
                                                        </span>
                                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                            @click="abrir_tabela(item.info_procedimentos[secundario.id_procedimento].id_item_tabela)">
                                                            <i class="fa-solid fa-magnifying-glass-dollar fa-fw"></i>
                                                        </button>
                                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                            @click="copiar_clipboard(item.info_procedimentos[secundario.id_procedimento].st_codigo)">
                                                            <i class="fas fa-copy fa-fw"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input
                                                v-else
                                                sizing="sm"
                                                label="Código"
                                                :edicao="false"
                                                :compact="true">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="!item.fl_apac">
                                                        <span class="input-group-text" id="basic-addon2" title="Tabela não identificada.">
                                                            <i class="fa-solid fa-triangle-exclamation text-danger fa-fw"></i>
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                sizing="sm"
                                                label="SUS"
                                                :edicao="false"
                                                :compact="true"
                                                :value="item.info_procedimentos[secundario.id_procedimento] ? item.info_procedimentos[secundario.id_procedimento].st_codigo_sus : secundario.st_codigo_sus">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                                            @click="copiar_clipboard(info_proc(secundario.id_procedimento) ? info_proc(secundario.id_procedimento).st_codigo_sus : secundario.st_codigo_sus)">
                                                            <i class="fas fa-copy"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-6" v-if="item.info_procedimentos[secundario.id_procedimento] && item.info_procedimentos[secundario.id_procedimento].amostras && item.info_procedimentos[secundario.id_procedimento].amostras.length">
                                            <az-input
                                                v-if="item.info_procedimentos[secundario.id_procedimento].amostras.length == 1"
                                                label="Material"
                                                :compact="true"
                                                sizing="sm"
                                                :edicao="false"
                                                :value="item.info_procedimentos[secundario.id_procedimento].amostras[0].st_amostra_material" />

                                            <az-input
                                                v-else
                                                label="Material"
                                                :compact="true"
                                                sizing="sm"
                                                :validate="validate"
                                                type="select"
                                                :optionsList="item.info_procedimentos[secundario.id_procedimento].amostras"
                                                optionsDisplay="st_amostra_material"
                                                optionsData="id_amostra_material"
                                                v-model="secundario.id_amostra_material" />
                                        </div>
                                    </div>

                                    <div class="form-row mb-2"  :key="'G' + isx" :class="cor_linha(secundario)" v-if="secundario.info_guia">
                                        <div class="col col-12 col-md-1">
                                        </div>
                                        <div class="col col-12 col-md-5">
                                            <az-input 
                                                sizing="sm"
                                                label="Guia Operadora"
                                                :compact="true"
                                                v-model="secundario.st_guia_operadora" />
                                        </div>
                                        <div class="col col-12 col-md-5">
                                            <az-input 
                                                sizing="sm"
                                                label="Guia Prestador"
                                                :compact="true"
                                                v-model="secundario.st_guia_prestador" />
                                        </div>
                                    </div>

                                </div>

                                <div>
                                    <!-- 
                                        v-if="!item.marcacao || item.fl_apac || ( item.procedimento && item.procedimento.id_especialidade == 2 ) "
                                        :optionsName="$store.state.user.proc_oper ? 'procedimentos.agenda.op.' + dados.plano.id_operadora : 'procedimentos.agenda'"
                                        :optionsParm="$store.state.user.proc_oper ? { id_operadora: dados.plano.id_operadora } : {}"
                                        :optionsSync="false"
                                    -->
                                    <az-input
                                        placeholder="Adicionar procedimento..."
                                        sizing="sm"
                                        icon="fas fa-plus fa-fw"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="procedimentos.index" 
                                        :optionsParm="{
                                            agenda: true, 
                                            agenda_add: true, 
                                            ativos: true, 
                                            id_medico: item.id_medico, 
                                            sus: item.fl_apac ? true : false, 
                                            id_plano: item.plano ? item.plano.id_plano : null,
                                            id_operadora: item.plano ? item.plano.id_operadora : null,
                                            id_unidade_operacao: item.id_unidade_operacao 
                                        }"
                                        :procsigla="true"
                                        v-model="novoProcedimento"
                                        ref="info_procedimento"
                                        @selecionado="incluirProcedimento()" />
                                </div>
                            </template>

                            <div class="form-row mt-3">
                                <div class="col col-12">
                                    <az-input
                                        label="Comentários"
                                        type="textarea"
                                        rows="3"
                                        :edicao2="item.in_status == 0"
                                        :validate="validate"
                                        v-model="item.st_comentarios" />
                                </div>
                            </div>

                            <div class="form-row mt-3" v-if="item.plano.operadora.fl_sus">
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="APAC"
                                        v-model="item.fl_apac" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.fl_apac && ( item.st_sus_nome_autorizador || item.st_sus_cns_autorizador || item.in_status == 1 || item.in_status == 4 )">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Nome do Autorizador"
                                        sizing="sm"
                                        :validate="validate"
                                        required
                                        v-model="item.st_sus_nome_autorizador" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="CNS do Autorizador"
                                        type="cns"
                                        sizing="sm"
                                        :validate="validate"
                                        :rules="['size:15']"
                                        required
                                        v-model="item.st_sus_cns_autorizador" />
                                </div>
                            </div>

                            <template v-if="item.contrato_operadora && item.contrato_operadora.fl_reembolso">
                                <template v-if="item.reembolso_fator">
                                    <div class="form-row mt-3">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                type="button-group"
                                                :optionsList="[
                                                    { id: 'dt', search: 'Datas' },
                                                    { id: 'val', search: 'Valores' },
                                                ]" 
                                                v-model="aut_view" />
                                        </div>
                                        <div class="col col-12 col-md-3 d-flex flex-column">
                                            <button type="button" class="btn btn-outline-primary" :disabled="$store.state.loading || aut_view != 'val'" @click="calcular_valores(item)">
                                                Calcular Valores
                                            </button>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                icon="fas fa-times fa-fw"
                                                :type="calc.troca ? 'number' : 'money'"
                                                :precision="5"
                                                v-model="item.dc_fator">
                                            </az-input>
                                        </div>
                                    </div>

                                    <div class="form-row mt-3" v-if="aut_view == 'val'">
                                        <template v-if="eh_sulamerica">
                                            <div class="col col-12 col-md-3 offset-md-6">
                                                <az-input
                                                    label="Valor"
                                                    type="money"
                                                    v-model="calc.valor">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon1">R$</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </template>
                                        <template v-else-if="eh_bradesco">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Base de Cálculo"
                                                    type="select"
                                                    :optionsList="[
                                                        { id: 'R', search: 'Valor em Real' },
                                                        { id: 'C', search: 'Valor da CRS' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="calc.tipo" 
                                                    @before="calc.troca = true" />
                                            </div>
                                            <template v-if="calc.tipo == 'R'">
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        id="qtd_crs"
                                                        label="Qtd de CRS (A)"
                                                        :type="calc.troca ? 'number' : 'money'"
                                                        v-model="calc.qtd" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        label="Valor em Real (B)"
                                                        type="money"
                                                        v-model="calc.us" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <small class="form-text text-muted text-nowrap text-truncate">
                                                        Fator (B/A)
                                                    </small>
                                                    <div class="input-group mb-0">
                                                        <label class="form form-control" disabled>
                                                        {{ $util.formatMoeda(calc.qtd ? calc.us / calc.qtd : 0, 5) }}
                                                    </label>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="calcular_fator()">
                                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </div>                                               
                                                </div>
                                            </template>
                                            <template v-else-if="calc.tipo == 'C'">
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        id="valor_crs"
                                                        label="Valor da CRS (A)"
                                                        :precision="5"
                                                        :type="calc.troca ? 'number' : 'money'"
                                                        v-model="calc.valor" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        label="Múltiplo (B)"
                                                        type="money"
                                                        v-model="calc.multiplo" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <small class="form-text text-muted text-nowrap text-truncate">
                                                        Fator (AxB)
                                                    </small>
                                                    <div class="input-group mb-0">
                                                        <label class="form form-control" disabled>
                                                        {{ $util.formatMoeda(calc.valor * calc.multiplo, 5) }}
                                                    </label>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="calcular_fator()">
                                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </div>                                               
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Qtd US/URS/CRS"
                                                    type="money"
                                                    :precision="5"
                                                    v-model="calc.qtd" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Valor US/URS/CRS"
                                                    type="money"
                                                    v-model="calc.valor" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Múltiplo de Reembolso"
                                                    type="money"
                                                    v-model="calc.multiplo" />
                                            </div>
                                        </template>
                                        <div class="col col-12 col-md-3" v-if="!eh_bradesco">
                                            <az-input
                                                label="US"
                                                type="money"
                                                v-model="calc.us">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="calc.us != 1">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="calcular_fator()">
                                                            <i class="fas fa-calculator"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>

                                    <pre v-if="false">{{ calc }}</pre>
                                </template>

                                <template v-else>
                                    <div class="form-row mt-3" v-if="item.contrato_operadora && item.contrato_operadora.fl_reembolso">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                label="Valor Solicitado"
                                                type="money"
                                                :validate="validate"
                                                v-model="item.dc_valor_solic" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                label="Valor Autorizado"
                                                type="money"
                                                :validate="validate"
                                                v-model="item.dc_valor_aut" />
                                        </div>
                                    </div>
                                </template>
                            </template>

                            <template v-else-if="item.pode_editar_valores">
                                <div class="form-row mt-3">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            type="button-group"
                                            :optionsList="[
                                                { id: 'dt', search: 'Datas' },
                                                { id: 'val', search: 'Valores' },
                                            ]" 
                                            v-model="aut_view" />
                                    </div>
                                    <div class="col col-12 col-md-6 d-flex flex-column">
                                        <button type="button" class="btn btn-outline-primary" :disabled="$store.state.loading || aut_view != 'val'" @click="calcular_valores(item)">
                                            Calcular Valores
                                        </button>
                                    </div>
                                </div>
                            </template>

                            <!-- Cassetes / Anatomia Patológica -->
                            <template v-if="item.requisicao_procedimento && item.requisicao_procedimento.cassetes && item.requisicao_procedimento.cassetes.length">
                                <div class="alert alert-secondary">
                                    <div v-if="item.requisicao_procedimento.item">{{ item.requisicao_procedimento.item.search }}</div>
                                    <div v-if="item.requisicao_procedimento.st_observacoes" class="small text-muted">
                                        {{ item.requisicao_procedimento.st_observacoes }}
                                    </div>
                                    <div v-if="item.requisicao_procedimento.js_classes" class="mb-2">
                                        <span class="badge badge-success mr-1" v-for="(classe, icx) in item.requisicao_procedimento.js_classes" :key="icx">
                                            {{ classe }}
                                        </span>
                                    </div>
                                    <ul class="list-group">
                                        <li class="list-group-item py-2 small d-flex justify-content-between" v-for="(cassete, icx) in item.requisicao_procedimento.cassetes" :key="icx">
                                            <div v-if="cassete.amostra">
                                                {{ cassete.amostra.st_codigo }} / {{ cassete.amostra.st_titulo }}
                                            </div>
                                            <div v-if="cassete.js_classes">
                                                <span class="badge badge-success mr-1" v-for="(classe, icx) in cassete.js_classes" :key="icx">
                                                    {{ classe }}
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </template>

                            <!-- OPMEs -->
                            <solicitacao-autorizacao-material
                                :validate="validate"
                                :edicao="item"
                                class="mt-3" />

                            <template v-if="item.marcacao && item.marcacao.infusao && item.marcacao.infusao.protocolo && item.marcacao.infusao.protocolo.receita">
                                <order-set-view 
                                    :dados="[item.marcacao.infusao.protocolo.receita]"
                                    type="receita" />
                            </template>

                            <az-instrucoes
                                v-if="item"
                                class="mt-3"
                                ref="instruc_aut"
                                dados2="item"
                                cores2="cores"
                                :autorizacao="true"
                                procedimentos2="data && dados.procedimento ? [dados] : procedimentos"
                                contexto="Z" />

                            <br><br><br><br><br>

                        </template>

                    </div>
                    <div class="modal-footer" v-if="item">
                        <span class="badge badge-secondary mr-2" v-if="item.js_secundarios">
                            {{ item.js_secundarios.length + 1 }}
                        </span>
                        <button type="button" class="btn btn-outline-danger" title="Negar itens sem informação de tabela de preço." @click="negar_sem_tabela(item)" v-if="show_codes">
                            <i class="fa fa-ban fa-fw" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-outline-secondary" title="Exibir Códigos" @click="show_codes = !show_codes">
                            <i class="fa-solid fa-eye fa-fw" v-if="show_codes"></i>
                            <i class="fa-solid fa-eye-slash fa-fw" v-else></i>
                        </button>
                        <az-audit-log-button model="solicitacaoAutorizacao" :id="item.id_solicitacao_autorizacao" v-if="item && item.id_solicitacao_autorizacao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="autorizar_save()" :disabled2="item.in_status != 0">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="edicaoSolicModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total" v-if="modal_tipo == 'editar'">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Editar Solicitação de Autorização
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_solicitacao_autorizacao">
                                #{{ item.id_solicitacao_autorizacao }}
                            </span>

                            <span class="small text-muted ml-2" v-if="item && item.id_solicitacao_autorizacao_origem">
                                Origem {{ item.id_solicitacao_autorizacao_origem }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <az-empty-state v-if="!item" />

                        <template v-if="item">

                            <div class="d-flex justify-content-between mb-3">
                                <div>
                                    <div v-if="item.unidade_operacao">
                                        <i class="fa fa-building-o fa-fw mr-2" aria-hidden="true"></i>
                                        {{ item.unidade_operacao.search }}
                                    </div>
                                    <div>
                                        <i class="far fa-credit-card fa-fw mr-2"></i>
                                        {{ item.plano.search }}
                                    </div>
                                    <div>
                                        <i class="fas fa-play fa-fw mr-2"></i>
                                        {{ item.procedimento.search }}
                                        <small v-if="item.valor && item.valor.item_tabela && item.procedimento.search != item.valor.item_tabela.st_nome">
                                            / {{ item.valor.item_tabela.st_nome }}
                                        </small>
                                        <span v-if="item.valor && item.valor.item_tabela">
                                            / {{ item.valor.item_tabela.st_codigo }}
                                        </span>
                                        <span v-else-if="item.plano.operadora && item.plano.operadora.fl_sus && item.procedimento.st_codigo_sus">
                                            / {{ item.procedimento.st_codigo_sus }}
                                        </span>
                                        <span class="text-muted" v-if="item.in_quantidade > 1">
                                            x{{ item.in_quantidade }}
                                        </span>
                                    </div>
                                    <div>
                                        <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                        {{ item.medico.search }}
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <span v-if="item.medico.conselho">
                                            {{ item.medico.conselho.st_sigla }}
                                            {{ item.medico.in_numero_conselho }}
                                        </span>
                                    </div>
                                    <div>
                                        <template v-if="!item.marcacao || !item.marcacao.id_atendimento">
                                            <a href="#" class="card-link" @click.prevent="recalc_contrato_operadora()">
                                                <i class="fas fa-sync-alt fa-fw mr-2"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <i class="fa fa-file fa-fw mr-2" aria-hidden="true"></i>
                                        </template>
                                        Contrato
                                        {{ item.contrato_operadora ? item.contrato_operadora.st_numero_prestador : "" }}
                                        <small v-if="item.contrato_operadora && item.contrato_operadora.st_nome_contratado">
                                            / {{ item.contrato_operadora.st_nome_contratado }}
                                        </small>
                                        <small v-if="1 == 0 && item.contrato_operadora && item.contrato_operadora.st_cnes">
                                            / CNES {{ item.contrato_operadora.st_cnes }}
                                        </small>
                                    </div>
                                    <template v-if="item.js_secundarios">
                                        <template v-for="(outro, iox) in item.js_secundarios">
                                            <div :key="iox" v-if="iox < 5 || show_secs">
                                                <i class="fa fa-plus fa-fw mr-2" aria-hidden="true"></i>
                                                {{ outro.st_procedimento ? outro.st_procedimento : outro.search }}
                                                <span class="text-muted" v-if="outro.in_quantidade > 1">
                                                    x{{ outro.in_quantidade }}
                                                </span>
                                            </div>
                                        </template>

                                        <div :key="iox" v-if="item.js_secundarios.length > 5">
                                            <a href="#" @click.prevent="show_secs = !show_secs" class="card-link">
                                                {{ show_secs ? 'Esconder' : 'Exibir Demais' }}
                                                <span class="badge badge-secondary">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                    {{ item.js_secundarios.length - 5 }}
                                                </span>
                                            </a>
                                        </div>
                                    </template>
                                </div>
                                <div>
                                    <a :href="item.plano.operadora.st_site" target="_blank" v-if="item.plano.operadora && item.plano.operadora.st_site">
                                        {{ item.plano.operadora.st_site }}
                                    </a>
                                </div>
                            </div>

                            <div class="form-row">

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Nome do Paciente"
                                        :edicao="!item.id_paciente"
                                        v-model="item.nome_paciente" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        label="Operadora/Plano"
                                        sizing="sm"
                                        placeholder="Operadora/Plano"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="planos.index"
                                        :optionsSync="false"
                                        optionsData="id_plano"
                                        v-model="item.id_plano"
                                        :edicao="!item.marcacao"
                                        ref="info_plano" />
                                </div>

                                <template v-if="item.fl_apac">

                                    <div class="col col-12 col-md-2" v-if="item.id_paciente && item.paciente.paciente_unidade">

                                        <az-input
                                            sizing="sm"
                                            label="CNS (Cartão Nacional de Saúde)"
                                            type="cns"
                                            :validate="validate"
                                            :rules="['size:15']"
                                            v-model="item.paciente.paciente_unidade.st_sus">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="item.paciente.paciente_unidade.st_sus">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="copiar_clipboard(item.paciente.paciente_unidade.st_sus)">
                                                        <i class="fas fa-copy"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>

                                    </div>

                                    <div class="col col-12 col-md-2" v-if="item.id_paciente && item.paciente.cadastro">

                                        <az-input
                                            sizing="sm"
                                            label="CPF"
                                            type="cpf"
                                            :edicao="false"
                                            v-model="item.paciente.cadastro.st_cpf">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="item.paciente.cadastro.st_cpf">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="copiar_clipboard(item.paciente.cadastro.st_cpf)">
                                                        <i class="fas fa-copy"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>

                                    </div>

                                    <div class="col col-12 col-md-1" v-if="item.paciente && item.paciente.cadastro">

                                        <az-input 
                                            sizing="sm"
                                            label="Raça" 
                                            type="select" 
                                            v-model="item.paciente.cadastro.st_raca" 
                                            :optionsList="[
                                                { id: '01', search: 'Branca' }, 
                                                { id: '02', search: 'Preta' }, 
                                                { id: '03', search: 'Parda' }, 
                                                { id: '04', search: 'Amarela' }, 
                                                { id: '05', search: 'Indígena' }, 
                                            ]"
                                            optionsData="id" />
                        
                                    </div>

                                </template>

                                <template v-else>

                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Número da Matrícula"
                                            v-model="item.numero_carteira">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="item.numero_carteira">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="copiar_clipboard(item.numero_carteira)">
                                                        <i class="fas fa-copy"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Vencimento da Matrícula"
                                            type="date"
                                            :edicao="item.numero_carteira ? true : false"
                                            v-model="item.validade_carteira" />
                                    </div>

                                </template>


                            </div>

                            <div class="form-row mt-2" v-if="item.fl_apac || ( item.plano && item.plano.operadora && item.plano.operadora.fl_sus )">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Faturamento SUS"
                                        v-model="item.fl_apac" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Laudo (LEA) Indivualizado"
                                        v-model="item.fl_lea_indiv" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.procedimento.id_classe_procedimento == 2">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Acomodação"
                                        sizing="sm"
                                        type="select"
                                        :optionsList="[
                                            {id: 'A', search: 'Apartamento'},
                                            {id: 'E', search: 'Enfermaria'}
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="item.st_acomodacao" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Diárias"
                                        sizing="sm"
                                        type="number"
                                        placeholder="Não informado..."
                                        v-model="item.in_diarias"
                                        :validate="validate" />
                                </div>
                            </div>

                            <div class="card mt-3" v-if="!item.id_paciente && item.cadastro_temporario">
                                <div class="card-header d-flex justify-content-between">
                                    <a class="card-link" data-toggle="collapse" href="#collapseDadosPaciente">
                                        Dados do Paciente Primeira Vez
                                    </a>
                                    <div v-if="item.cadastro_temporario && item.cadastro_temporario.id_cadastro_temporario">
                                        <az-audit-log-button model="cadastroTemporario" :link="true" sizing="sm" :id="item.cadastro_temporario.id_cadastro_temporario" />
                                    </div>
                                </div>
                                <div class="collapse" id="collapseDadosPaciente">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col col-12 col-md-3" id="campo-cadastro-temporario">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Sexo" 
                                                    type="sexo" v-model="item.cadastro_temporario.ch_sexo" 
                                                    required :validate="validate" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Data de Nascimento" 
                                                    type="date" v-model="item.cadastro_temporario.dt_nascimento" 
                                                    :validate="validate" :rules="['nasc']" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Telefone" 
                                                    type="fone" v-model="item.cadastro_temporario.st_telefone" 
                                                    :validate="validate" :rules="['fone']" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Celular" 
                                                    type="fone" v-model="item.cadastro_temporario.st_celular" 
                                                    :validate="validate" :rules="['fone']" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col col-12 col-md-6">
                                                <az-input sizing="sm" label="e-mail" 
                                                    type="email" v-model="item.cadastro_temporario.st_email" 
                                                    :validate="validate" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input   
                                                    sizing="sm"
                                                    label="CPF"
                                                    type="cpf"
                                                    :validate="validate" 
                                                    v-model="item.cadastro_temporario.st_cpf" />
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input 
                                                    sizing="sm"
                                                    label="RG" 
                                                    type="text" 
                                                    v-model="item.cadastro_temporario.st_rg" 
                                                    :validate="validate" 
                                                    :rules="['rg']" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col col-12 col-md-6">
                                                <az-input   
                                                    sizing="sm"
                                                    label="Nome da Mãe"
                                                    :validate="validate" 
                                                    v-model="item.cadastro_temporario.st_nome_mae" />
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Nome Social" 
                                                    v-model="item.cadastro_temporario.st_nome_social" 
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                        <cadastro-endereco 
                                            sizing="sm"
                                            v-if="item.cadastro_temporario.endereco"
                                            :validate="validate"
                                            v-model="item.cadastro_temporario.endereco" />

                                        <div class="row" v-if="item.plano && item.plano.operadora && item.plano.operadora.fl_sus">
                                            <div class="col col-12 col-md-6">
                                                <az-input 
                                                    sizing="sm"
                                                    label="Raça" 
                                                    type="select" 
                                                    v-model="item.cadastro_temporario.st_raca" 
                                                    :optionsList="[
                                                        { id: '01', search: 'Branca' }, 
                                                        { id: '02', search: 'Preta' }, 
                                                        { id: '03', search: 'Parda' }, 
                                                        { id: '04', search: 'Amarela' }, 
                                                        { id: '05', search: 'Indígena' }, 
                                                    ]"
                                                    optionsData="id"
                                                    :validate="validate" />
                                            </div>

                                            <div class="col col-12 col-md-6" v-if="item.cadastro_temporario.st_raca == '05'">
                                                <az-input 
                                                    placeholder="Selecione..."
                                                    sizing="sm"
                                                    label="Etnia" 
                                                    type="select" 
                                                    service="pacientes.etnias" 
                                                    v-model="item.cadastro_temporario.st_etnia" 
                                                    optionsMode="aql"
                                                    optionsData="id"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="form-row mt-2" v-if="item.fl_apac || ( !item.in_status && item.marcacoes && !item.marcacoes.length )">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        icon="fas fa-user-md fa-fw"
                                        type="select"
                                        placeholder="Selecione o Médico..."
                                        optionsMode="aql"
                                        service="medicos.index"
                                        optionsName="medicos-cadastro"
                                        :optionsParm="{ ativos: true }"
                                        optionsData="id_pessoa"
                                        v-model="item.id_medico" />
                                </div>
                            </div>

                            <div class="form-row">

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Nome do Solicitante"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="medico_solicitantes.index"
                                        optionsDisplay="search"
                                        :optionsSync="true"
                                        :optionsExternal="true"
                                        :validate="validate"
                                        v-model="item.medico_solicitante"
                                        @onSearch="setNomeMedico"
                                        v-if="!item.medico_solicitante || item.medico_solicitante.id_medico_solicitante">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!item.medico_solicitante">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="novo_medico(item)">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>

                                    <az-input
                                        label="Nome do Solicitante"
                                        sizing="sm"
                                        placeholder="Informe o nome para realizar o cadastro..."
                                        v-if="item.medico_solicitante && !item.medico_solicitante.id_medico_solicitante"
                                        v-model="item.medico_solicitante.st_nome">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="item.medico_solicitante = null">
                                                    <i class="fa fa-search" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <template v-if="item.medico_solicitante && !( item.medico_solicitante instanceof String )">

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Número do Conselho"
                                            sizing="sm"
                                            type="text"
                                            v-model="item.medico_solicitante.st_numero_conselho"
                                            :edicao="!item.medico_solicitante.id_medico_solicitante"
                                            :validate="validate" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Conselho"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="conselhos.index"
                                            optionsData="id_conselho"
                                            optionsDisplay="st_sigla"
                                            v-model="item.medico_solicitante.id_conselho"
                                            :edicao="!item.medico_solicitante.id_medico_solicitante"
                                            :validate="validate" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="UF"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="estados.index"
                                            optionsData="id_estado"
                                            optionsDisplay="st_estado"
                                            v-model="item.medico_solicitante.id_estado_conselho"
                                            :edicao="!item.medico_solicitante.id_medico_solicitante"
                                            :validate="validate" />
                                    </div>

                                </template>

                            </div>

                            <div class="form-row" v-if="item.medico_solicitante && !( item.medico_solicitante instanceof String )">

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="CBO / Especialidade"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="especialidades.index"
                                        optionsDisplay="search"
                                        :optionsSync="false"
                                        v-model="item.medico_solicitante.especialidade"
                                        :validate="validate" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Data da Solicitação"
                                        sizing="sm"
                                        type="date"
                                        v-model="item.dt_solicitacao"
                                        required
                                        :validate="validate" />
                                </div>

                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        type="select"
                                        :optionsList="lista_unidades"
                                        optionsData="id_unidade_operacao"
                                        placeholder="Todas as Unidades..."
                                        :edicao="!item.marcacao"
                                        v-model="item.id_unidade_operacao" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input label="CID Principal"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="cids.index"
                                        optionsData="id_cid"
                                        optionsDisplay="search"
                                        v-model="item.id_cid_principal"
                                        :validate="validate" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input label="CID Secundário"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="cids.index"
                                        optionsData="id_cid"
                                        optionsDisplay="search"
                                        v-model="item.id_cid_secundario"
                                        :validate="validate" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input label="CID Causas Associadas"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="cids.index"
                                        optionsData="id_cid"
                                        optionsDisplay="search"
                                        v-model="item.id_cid_causa_assoc"
                                        :validate="validate"  />
                                </div>
                            </div>

                            <div class="row" v-if="item.id_apoiado">
                                <div class="col col-12">
                                    <az-input
                                        label="Apoiado"
                                        sizing="sm"
                                        type="autocomplete"
                                        service="apoiados.index"
                                        optionsMode="aql"
                                        optionsName="apoiados.index"
                                        v-model="item.apoiado" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <small class="text-muted">Classificação</small>
                                    <multiselect
                                        v-model="item.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        placeholder="Selecione uma classificação..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <!-- Campos para AIH -->

                            <template v-if="item.fl_aih || ( item.fl_apac && item.procedimento && item.procedimento.js_info && item.procedimento.js_info.tipo_lea == 'AIH' )"> 
                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            label="PRINCIPAIS SINAIS E SINTOMAS CLÍNICOS"
                                            type="textarea"
                                            rows="3"
                                            v-model="item.st_observacoes" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            label="CONDIÇÕES QUE JUSTIFICAM A INTERNAÇÃO"
                                            type="textarea"
                                            rows="3"
                                            v-model="item.st_aih_just_int" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            label="PRINCIPAIS RESULTADOS DE PROVAS DIAGNÓSTICAS (RESULTADOS DE EXAMES REALIZADOS)"
                                            type="textarea"
                                            rows="3"
                                            v-model="item.st_aih_just_res" />
                                    </div>
                                </div>
                            </template>

                            <!-- Campos para demais autorizações -->

                            <template v-else>
                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Justificativa"
                                            type="textarea"
                                            rows="3"
                                            v-model="item.st_observacoes" />
                                    </div>
                                </div>
                            </template>

                            <template v-if="( item.plano && item.plano.operadora && item.plano.operadora.fl_sus ) || 1==1"> <!-- || 1 == 1 -->
                                <div class="form-row" v-if="item.textos_padrao && item.textos_padrao.length">
                                    <div class="col col-12">
                                        <div class="list-group">
                                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                                                @click="incluir_texto(item, texto)"
                                                v-for="(texto, itx) in item.textos_padrao" :key="itx">
                                                <div>{{ texto.st_titulo }}</div>
                                                <div v-if="texto.js_classes">
                                                    <span class="badge badge-success ml-1" v-for="(classe, icx) in texto.js_classes" :key="icx">{{ classe }}</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="item.pedido">

                                <div class="alert alert-info mt-2 mb-1 py-1">
                                    {{ $util.getFormatDate(item.pedido.atendimento_procedimento.atendimento.dt_inicio) }}
                                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    {{ item.pedido.atendimento_procedimento.procedimento.search }}
                                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                    {{ item.pedido.atendimento_procedimento.atendimento.medico.st_nome_exibicao }}

                                    <template v-if="item.marcacao && item.marcacao.infusao && item.marcacao.infusao.st_titulo">
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        {{ item.marcacao.infusao.st_titulo }}
                                    </template>
                                </div>

                                <div class="form-row mt-2">
                                    <template v-if="item.marcacao && item.marcacao.infusao && item.pedido.receita">
                                        <div class="col col-12 col-md-6">
                                            <div>Prescrição:</div>
                                            <ul class="list-group">
                                                <li class="list-group-item" v-for="(receita, irx) in item.pedido.receita" :key="irx">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="small">
                                                            Prescrição
                                                        </div>
                                                        <div class="text-nowrap">
                                                            <button type="button" class="btn btn-sm btn-outline-primary" @click.prevent="imprimir_receita(receita)">
                                                                Padrão
                                                            </button>
                                                            <a type="button" class="btn btn-sm btn-outline-primary ml-1" :href="receita.doc_certificado.arquivo.temporary_url" v-if="receita.doc_certificado" target="_blank">
                                                                <i class="fa-solid fa-file-contract"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div v-if="receita.st_observacoes_interno" class="alert alert-secondary text-dark mt-2 mb-1 py-2 d-flex justify-content-between">
                                                        <div style="white-space: pre-wrap;">{{ receita.st_observacoes_interno }}</div>
                                                        <div><i class="fas fa-thumbtack"></i></div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="col col-12 col-md-6">
                                            <div>Requisições:</div>
                                            <ul class="list-group">
                                                <li class="list-group-item" v-for="(requisicao, irx) in item.pedido.requisicao" :key="irx">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="small">
                                                            {{ requisicao.lista_items }}
                                                        </div>
                                                        <div class="text-nowrap">
                                                            <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click.prevent="imprimir_requisicao(requisicao)">
                                                                Guia
                                                            </button>
                                                            <button type="button" class="btn btn-sm btn-outline-primary" @click.prevent="imprimir_requisicao(requisicao, 'padrao')">
                                                                Padrão
                                                            </button>
                                                            <a type="button" class="btn btn-sm btn-outline-primary ml-1" :href="requisicao.doc_certificado.arquivo.temporary_url" v-if="requisicao.doc_certificado" target="_blank">
                                                                <i class="fa-solid fa-file-contract"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div v-if="requisicao.st_observacoes_interno" class="alert alert-secondary text-dark mt-2 mb-1 py-2 d-flex justify-content-between">
                                                        <div style="white-space: pre-wrap;">{{ requisicao.st_observacoes_interno }}</div>
                                                        <div><i class="fas fa-thumbtack"></i></div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>

                                    <div class="col col-12 col-md-6">
                                        <div class="d-flex justify-content-between">
                                            <div>Relatórios:</div>
                                            <div>
                                                <a href="#" v-for="(tag, itx) in lista_doc_tags" :key="itx" @click.prevent="tag.selec = !tag.selec">
                                                    <span class="badge ml-1" :class="'badge-' + ( tag.selec ? 'success' : 'secondary' )">
                                                        {{ tag.tag }}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <ul class="list-group">
                                            <li class="list-group-item" v-for="(doc, idx) in lista_documentos" :key="idx">
                                                <a href="#" @click.prevent="imprimir_documento(doc)">
                                                    {{ doc.st_titulo }}
                                                </a>
                                                <a :href="doc.doc_certificado.arquivo.temporary_url" v-if="doc.doc_certificado" target="_blank">
                                                    <i class="fa-solid fa-file-contract ml-2"></i>
                                                </a>
                                                <div class="small text-muted" v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo">
                                                    {{ doc.modelo_documento.st_nome }}
                                                </div>
                                                <div v-if="doc.modelo_documento && doc.modelo_documento.js_classes && doc.modelo_documento.js_classes.length">
                                                    <span class="badge badge-success" v-for="(tag, itx) in doc.modelo_documento.js_classes" :key="itx">{{ tag }}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </template>

                            <template v-if="item.marcacao">
                                <div class="alert alert-info mt-3">
                                    <div v-if="item.marcacao.campos_customizados && item.marcacao.campos_customizados.js_campos.length" class="row">
                                        <div class="col col-12">
                                            <span>{{ item.marcacao.campos_customizados.st_titulo }}</span>
                                            <formulario
                                                :gutters="true"
                                                v-model="item.marcacao.campos_customizados.js_campos"
                                                :saved="true"
                                                mode="view"
                                                :config="true" />

                                            <hr>
                                        </div>
                                    </div>

                                    <span v-if="item.marcacao.st_observacoes">
                                        Observação: {{ item.marcacao.st_observacoes }}
                                    </span>
                                </div>
                            </template>

                            <!-- FORMS PARA ENVIO -->

                            <template v-if="false">
                                <az-sub-title title="Formulários"></az-sub-title>
                                (...)
                                <br><br><br>
                            </template>

                        </template>
                    </div>
                    <div class="modal-footer" v-if="item">
                        <az-audit-log-button model="solicitacaoAutorizacao" :id="item.id_solicitacao_autorizacao" v-if="item.id_solicitacao_autorizacao" />
                        <az-submit color="danger" @click="remover(item)" v-if="1 == 0 && !item.marcacao">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="save('edicaoSolicModal')"
                            v-if="!item.marcacao || !item.marcacao.id_atendimento || item.fl_apac">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="solicAutEnvioModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Envio</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="item.dt_envio">
                            <az-input
                                label="Envio"
                                type="date"
                                :edicao="false"
                                v-model="item.dt_envio" />

                            <az-input
                                label="Responsável"
                                :edicao="false"
                                v-if="item.usuario_envio"
                                v-model="item.usuario_envio.pessoa.st_nome" />

                            <p class="alert alert-info mt-3" v-if="item.st_observacao_envio">{{ item.st_observacao_envio }}</p>
                        </template>

                        <template v-else>

                            <az-input
                                label="Envio"
                                type="date"
                                v-model="item.data_envio" />

                            <az-input
                                label="Observação"
                                type="textarea"
                                v-model="item.st_observacao_envio" />

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_marcar_envio(true)" v-if="!item.dt_envio">Marcar como Enviado</az-submit>
                        <az-submit @click="salvar_marcar_envio(false)" color="danger" v-else>Cancelar Envio</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="autorizLogModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Log de Autorizaçōes Online</h5>
                    <button type="button" class="close" @click="fechar('autorizLogModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container" v-if="logAutorizacoes">
                        <div class="row ">
                            <az-input
                                icon="far fa-calendar fa-fw"
                                label="Selecione o Log"
                                placeholder="Selecione o Log"
                                type="select"
                                optionsMode="json"
                                :optionsList="logAutorizacoes"
                                optionsDisplay="created_at"
                                v-model="logAutorizacoesSelecionado">
                            </az-input>
                        </div>
                        <div class="row">
                            <template v-if="logAutorizacoesSelecionado">
                                <div>XML de envio</div>
                                <pre class="alert alert-warning text-wrap w-100">
                                    {{logAutorizacoesSelecionado.st_xml_envio}}
                                </pre>

                                <div>XML de retorno</div>
                                <pre class="alert alert-secondary text-wrap w-100" >
                                    {{logAutorizacoesSelecionado.st_xml_retorno}}
                                </pre>

                                <pre class="alert alert-info" >
                                    {{logAutorizacoesSelecionado.js_retorno}}
                                </pre>
                            </template>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('autorizLogModal')">Fechar</button>
                </div>
                </div>
            </div>
        </div>

        <!-- Autorização Online -->
        <autoriz-online ref="autoriz" @refresh="load()" />

        <!-- Envio de Arquivo -- load(false) -->
        <template v-if="acao_anexar && item_arq">
            <az-file-upload
                ref="upload"
                @refresh="refresh_arquivos()" 
                :multiple="true"
                :arquivos="item_arq.arquivos"
                :parms="{ model_type: item_arq.model, model_id: item_arq.id }" />
        </template>

        <!-- Modal Marcações Sessões-->
        <div class="modal fade" id="marcacaoSessaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="marc_sessoes">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Marcações
                            <span class="badge badge-secondary ml-3" v-if="marc_sessoes.separar" title="Marcações">
                                {{ lista_sessoes.length }}/{{ marc_sessoes.marcacoes.length }}
                            </span>
                            <span class="badge badge-secondary ml-3" v-else title="Marcações">
                                {{ marc_sessoes.marcacoes.length }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Identificação do Paciente -->
                        <div class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ marcacao: marc_sessoes }" />
                                <hr>
                                <celula-dados-procedimento :hor="{ marcacao: marc_sessoes }" :blockanexos="true" />
                            </div>
                        </div>

                        <template v-if="marc_sessoes.marcacoes.length > 1 && marc_sessoes.separar">
                            <div class="form-row mb-3">
                                <div class="col col-12">
                                    <az-periodo v-model="filtros_sessoes" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="false">
                                    <az-input
                                        icon="fa fa-search"
                                        placeholder="Pesquisar..."
                                        v-model="filtros_sessoes.pesquisar" />
                                </div>
                            </div>

                            <pre v-if="false">{{ $util.periodo_2_datas(filtros_sessoes) }}</pre>
                        </template>

                        <p class="alert alert-warning" v-if="!lista_sessoes.length">
                            {{ marc_sessoes.separar ? 'Nenhuma marcação identificada.' : 'Nenhuma marcação relacionada a solicitação de autorização' }}
                        </p>

                        <ul class="list-group" v-else>
                            <li class="list-group-item d-flex justify-content-between" v-for="(sessao, isx) in lista_sessoes" :key="isx">
                                <div>
                                    <span v-if="sessao.id_atendimento">
                                        <i class="fa fa-check-circle text-success mr-2" aria-hidden="true" title="Atendimento Realizado"></i>
                                    </span>
                                    <span v-else>
                                        <i class="fas fa-circle text-secondary mr-2" aria-hidden="true" title="Agendado"></i>
                                    </span>
                                    {{ $util.getFormatDate(sessao.dt_inicio) }}
                                    {{ sessao.dt_inicio.substr(11,5) }}
                                    <span class="ml-3 text-muted">
                                        {{ getHumanDay(sessao.dt_inicio) }}
                                    </span>
                                    <span class="ml-3" title="Número do Atendimento." v-if="sessao.id_atendimento">
                                        <a href="#" @click.prevent="abrir_atendimento({ marcacao: sessao })" class="card-link">
                                            #{{ sessao.id_atendimento }}
                                        </a>

                                        <span v-if="sessao.atendimento && sessao.atendimento.guias && sessao.atendimento.guias.length" class="ml-2">
                                            <a href="#" @click.prevent="ver_guia(guia)" v-for="(guia, igx) in sessao.atendimento.guias" :key="igx">
                                                <span class="badge mr-1" :class="'badge-' + guia.status_color" :title="guia.status_guia">
                                                    {{ guia.ch_status }}
                                                </span>
                                            </a>
                                        </span>
                                    </span>
                                    <div v-if="sessao.id_medico != marc_sessoes.id_medico">
                                        <span class="badge badge-secondary">
                                            {{ sessao.medico.st_nome_exibicao }}
                                        </span>
                                    </div>
                                </div>
                                <div v-if="marc_sessoes.separar && !sessao.id_atendimento">
                                    <input type="checkbox" v-model="sessao.selec" />
                                </div>
                                <div v-else-if="!sessao.id_atendimento">
                                    <a href="#" @click.prevent="vincular_marcacao(marc_sessoes, sessao, true)" title="Cancelamento da marcação." data-toggle="tooltip"
                                        :disabled="$store.state.loading">
                                        <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                    </a>

                                    <a href="#" @click.prevent="vincular_marcacao(marc_sessoes, sessao, true, true)" title="Desvincular da autorização." data-toggle="tooltip"
                                        :disabled="$store.state.loading" class="ml-5">
                                        <i class="fa-solid fa-link-slash text-danger"></i>
                                    </a>
                                </div>
                                <div v-else-if="sessao.id_atendimento">
                                    <a href="#" @click.prevent="vincular_marcacao(marc_sessoes, sessao, true)" title="Desvincular da autorização." data-toggle="tooltip"
                                        :disabled="$store.state.loading">
                                        <i class="fa-solid fa-link-slash text-danger"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>

                        <template v-if="marc_sessoes.separar && lista_sessoes.length">
                            <button type="button" class="btn btn-outline-primary btn-sm mt-3 mr-1" @click="marcar_sessoes()" :disabled="$store.state.loading">
                                Todas
                            </button>

                            <button type="button" class="btn btn-outline-primary btn-sm mt-3" @click="confirmar_separacao(marc_sessoes)" :disabled="$store.state.loading">
                                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="$store.state.loading"></span>
                                Confirmar Separação
                            </button>
                        </template>

                        <template v-else>

                            <button type="button" class="btn btn-outline-primary btn-sm mt-3" @click="obter_marcacoes(marc_sessoes)" :disabled="$store.state.loading">
                                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="$store.state.loading"></span>
                                Vincular Marcação
                            </button>

                            <div v-if="marc_sessoes.vincular" class="mt-3">
                                <p class="alert alert-warning" v-if="!marc_sessoes.vincular.length">
                                    Nenhum marcação disponível para vinculação.
                                </p>

                                <div v-else>
                                    <div class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action" v-for="(outra, iox) in marc_sessoes.vincular" :key="iox"
                                            :disabled="$store.state.loading" @click="vincular_marcacao(marc_sessoes, outra)">
                                            {{ $util.getFormatDate(outra.dt_inicio) }}
                                            {{ outra.dt_inicio.substr(11,5) }}
                                            <small>
                                                <div>{{ outra.procedimento.search }}</div>
                                                <div>{{ outra.medico.search }} </div>
                                                <div v-if="outra.plano">{{ outra.plano.search }} </div>
                                            </small>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" @click="separar_autoriz(marc_sessoes)" v-if="marc_sessoes.marcacoes && marc_sessoes.marcacoes.length > 1">Separar</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br><br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <reembolso-obter-credenciais ref="cred" />
        <amostras ref="amostras" :viewonly="true" />

        <!-- Modal Nova Agenda Direto -->
        <div class="modal fade" id="marcacaoDiretoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="agenda">
                    <div class="modal-header">
                        <h5 class="modal-title">Nova Marcação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input   
                                    label="Data"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="agenda.data" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input   
                                    label="Hora"
                                    type="time"
                                    :validate="validate"
                                    required
                                    v-model="agenda.hora" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary" @click="agendar(agenda.item, null, true)">Agendar</button>
                        <az-submit @click="salvar_agenda ()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Agenda Médico Modal -->
        <div class="modal fade" id="agendarMedicoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Agendar...</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3" v-if="agenda && agenda.acao && !block_incluir_direto">
                            <div class="col col-12 d-flex flex-column">
                                <az-input
                                    sizing="sm"
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'A', search: 'Agendar' },
                                        { id: 'I', search: 'Incluir' }
                                    ]"
                                    optionsData="id"
                                    v-model="agenda.acao"
                                    />
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input type="radio" value="S" v-model="medico_agendar">
                                </div>
                            </div>
                            <label class="form-control">Profissional Selecionado</label>
                        </div>
                        <div class="input-group mt-1">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input type="radio" value="Q" v-model="medico_agendar">
                                </div>
                            </div>
                            <label class="form-control">Outro Profissional</label>
                        </div>

                        <template v-if="agenda && medico_agendar == 'Q'"> <!-- ( agenda.cc || agenda.acao == 'I' ) && -->
                            <div class="row mt-3">
                                <div class="col col-12">
                                    <az-input
                                        label="Médico"
                                        type="autocomplete" 
                                        placeholder="Selecione..."
                                        optionsMode="aql"
                                        service="medicos.index"
                                        optionsName="medicos-cadastro"
                                        :optionsParm="{ ativos: true }"
                                        v-model="agenda.outro_medico" />
                                </div>
                            </div>
                        </template>

                        <template v-if="agenda && agenda.acao == 'I'">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input   
                                        label="Data"
                                        type="date"
                                        :validate="validate"
                                        required
                                        v-model="agenda.data" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input   
                                        label="Hora"
                                        type="time"
                                        :validate="validate"
                                        required
                                        v-model="agenda.hora" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_agenda()" v-if="agenda && agenda.acao == 'I'">Incluir</az-submit>
                        <button type="button" class="btn btn-success" @click="agendar(agenda, medico_agendar, true)" v-else>Agendar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modalchave certificado assinar -->
        <div class="modal fade" id="assinarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-signature mr-2"></i>
                            Assinar LEA
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                        <input 
                            type="text" 
                            id="password" 
                            style="-webkit-text-security: disc;" 
                            v-model="chave_lea" 
                            autocomplete="off"
                            required
                            class="form form-control" />

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_assinar_lea()">Fechar</button>
                        <az-submit @click="atualizar_assinar_lea ()">Assinar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="gerarOrcamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="solic_para_orc">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Orçamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Particular"
                            placeholder="Selecione o Particular..."
                            type="select"
                            optionsMode="aql"
                            optionsDisplay="st_plano"
                            service="planos.index"
                            :optionsParm="{ 
                                cadastro_unidade: true,
                                particular: true, 
                                id_unidade_operacao: solic_para_orc.id_unidade_operacao
                            }"
                            :optionsName="'planos-particulares-' + solic_para_orc.id_unidade_operacao"
                            v-model="solic_para_orc.plano_orcamento" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="gerar_orcamento(solic_para_orc, true)">Gerar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sessões do Pacote -->
        <div class="modal fade" id="qtdeSessaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sessões</h5>
                            <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="number"
                            required
                            v-model="qtde_sessoes" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_pacote (sel_pacote, qtde_sessoes)">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alterar Médico Solicitante -->
        <div class="modal fade" id="alterarSolicitanteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Profissional Solicitante</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="alert alert-info">
                            <div class="lead" v-if="item.paciente">{{ item.paciente.search }}</div>
                            <div class="lead" v-else-if="item.cadastro_temporario">{{ item.cadastro_temporario.st_nome }}</div>
                            <div>{{ item.procedimento.search }}</div>
                            <div>
                                <i class="fa-solid fa-stamp"></i>
                                {{ item.id_solicitacao_autorizacao }}
                            </div>
                        </div>  

                        <div class="alert alert-secondary" v-if="item.medico_solicitante">
                            {{ item.medico_solicitante.search }}
                        </div>

                        <az-input
                            label="Solicitante"
                            sizing="sm"
                            type="autocomplete"
                            optionsMode="aql"
                            service="medico_solicitantes.index"
                            optionsDisplay="search"
                            :optionsSync="true"
                            required
                            :validate="validate"
                            v-model="novo_solicitante">
                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="salvar_alterar_solicitante()">Alterar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Editar Quantidade Item -->
        <div class="modal" id="editarQuantidadeItemModal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content" v-if="edicao_qtde_item">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Quantidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input  
                            type="number"
                            :min="1"
                            :max="200"
                            v-model="qtde_editada" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('editarQuantidadeItemModal')">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="atualizar_qtde_item()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alterar Procedimento -->
        <alterar-procedimento ref="alterar_proc" @refresh="load()" />

        <!-- Formulário de Pré-Atendimento -->
        <form-pre-atende ref="formpre" />

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" />

        <!-- Item Tabela -->
        <cadastro-item-tabela ref="cadastroitemtabela" />

        <!-- Log de Comunicação -->
        <solicitacao-autoriz-log ref="log_autoriz" />

        <!-- Clonar Solicitação -->
        <clonar-solicitacao-autoriz ref="clone" @refresh="load()" />

        <!-- Cadastrar Novo Paciente -->
        <cadastrar-novo-paciente ref="cadnovo" @refresh="load()" />

        <!-- Guia -->
        <guia-edicao ref="guia" :viewonly="true" />

        <!-- Pré Atendimento -->
        <documento-pre-atendimento ref="doc_pre_atend" />

        <!-- Registrar Contatos -->
        <registrar-contatos 
            :lista_status="lista_status ? lista_status.filter(item => item.id_contato_status != 'R') : []" 
            ref="regcontatos" 
            @refresh="load()">
            <template v-slot:info>
                <div class="alert alert-secondary" v-if="edicao_contatos">
                    <span v-if="edicao_contatos.paciente" class="lead">
                        {{ edicao_contatos.paciente.st_nome }}
                    </span>
                    <span v-else-if="edicao_contatos.cadastro_temporario" class="lead">
                        {{ edicao_contatos.cadastro_temporario.st_nome }}
                    </span>

                    <div>
                        #{{ edicao_contatos.id_solicitacao_autorizacao }}
                        <span class="badge badge-light ml-3" v-if="edicao_contatos.unidade_operacao && edicao_contatos.unidade_operacao.st_sigla">
                            {{ edicao_contatos.unidade_operacao.st_sigla }}
                        </span>
                    </div>
                    <div v-if="edicao_contatos.dt_solicitacao">
                        {{ $util.getFormatDate(edicao_contatos.dt_solicitacao) }}
                    </div>
                    <div v-if="edicao_contatos.plano" class="small">
                        {{ edicao_contatos.plano.search }}
                    </div>

                    <hr>

                    <div v-if="edicao_contatos.procedimento">
                        {{ edicao_contatos.procedimento.search }}
                    </div>
                    <div v-if="edicao_contatos.medico" class="small">
                        {{ edicao_contatos.medico.search }}
                    </div>
                </div>
            </template>
        </registrar-contatos>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import NovaSolicitacaoAutorizacao from './NovaSolicitacaoAutorizacao.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaHorariosMarcacao from '../../shared/table/CelulaHorariosMarcacao.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import AutorizOnline from './AutorizOnline.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Formulario from '../consultorio/Formulario.vue';
import ReembolsoObterCredenciais from '../recepcao/ReembolsoObterCredenciais.vue';
import LaboratorioEtiqueta from '../recepcao/LaboratorioEtiqueta.vue';
import Amostras from '../laboratorio/Amostras.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import AlterarProcedimento from '../recepcao/AlterarProcedimento.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import FormPreAtende from './FormPreAtende.vue';
import Multiselect from 'vue-multiselect';
import Documento from '../consultorio/Documento.vue';
import CadastroItemTabela from '../../cadastros/shared/CadastroItemTabela.vue';
import SolicitacaoAutorizLog from './SolicitacaoAutorizLog.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import AutEquipeCirurgia from './AutEquipeCirurgia.vue';
import OrderSetView from '../consultorio/OrderSetView.vue';
import ClonarSolicitacaoAutoriz from './ClonarSolicitacaoAutoriz.vue';
import CadastrarNovoPaciente from '../callcenter/CadastrarNovoPaciente.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import GuiaEdicao from '../faturamento/GuiaEdicao.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import SolicitacaoAutorizacaoMaterial from './SolicitacaoAutorizacaoMaterial.vue';


export default {
    data() {
        return {
            filtros: {
                from: "",
                to: "",
                id_operadora: "",
                pesquisar: "",
                status: "",
                periodo: "s",
                ref_data: "",
                id_unidade_operacao: "",
                id_medico: "",
                recepcao: false,
                id_fila_autorizacao: this.$util.getCookie('sol-aut-fila'),
                paciente: "",
                filtro_atend: "", 
                op_filtro: "PAC", 
                id_contato_status: "", 
                tipo_ordem: "", 
                ordem_dir: "A"
            },
            filtros_sessoes: { 
                periodo: "m",
                pesquisar: "", 
            },
            dados: null,
            item: null,
            item_arq: null, 
            validate: false,
            acao_anexar: false,
            montando: true,
            marc_sessoes: null,
            lista_status_autorizacao: [
                { id: 0, search: 'Aberto' },
                { id: 6, search: 'Enviado' },
                { id: 1, search: 'Autorizado' },
                { id: 9, search: 'On-line' },
                { id: 2, search: 'Em Análise' },
                { id: 3, search: 'Negado' },
                { id: 4, search: 'Aut. Parcial' },
                { id: 5, search: 'Cancelado' },
                { id: 10, search: 'Em Sessão' },
                { id: 11, search: 'Pendente' },
                { id: 12, search: 'Particular' },
            ],
            page: 1,
            canceltoken: null,
            logAutorizacoes: null,
            logAutorizacoesSelecionado: null,
            aut_view: "dt", 
            agenda: null, 
            calc: { 
                qtd: 0,
                valor: 0,
                multiplo: 1,
                us: 30, 
                troca: false, 
                tipo: 'C', 
            },
            novoProcedimento: "",
            lista_doc_tags: [], 
            options_classes: [],
            medico_agendar: "S",
            ja_buscou: false,  
            chave_lea: null,
            solicitacao_lea: null,
            chaves_medicos: [],
            show_codes: false, 
            show_secs: false, 
            modal_tipo: "", 
            solic_para_orc: null, 

            pacotes: null, 
            indexProcPacote: null, 
            sel_pacote: null, 
            qtde_sessoes: null, 
            block_incluir_direto: false, 

            novo_solicitante: null, 

            edicao_contatos: null, 
            lista_status: null, 

            edicao_qtde_item: null, 
            qtde_editada: null, 
        }
    },

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        ConfigMainTitle,
        NovaSolicitacaoAutorizacao,
        CelulaDadosProcedimento,
        CelulaDadosPaciente,
        CelulaHorariosMarcacao,
        AzFileUpload,
        AutorizOnline,
        AzPeriodo,
        HistoricoPacotesPaciente,
        AzAuditLogButton,
        Formulario,
        ReembolsoObterCredenciais, 
        LaboratorioEtiqueta, 
        Amostras,
        CadastroEndereco,
        AlterarProcedimento,
        AzSubTitle, 
        FormPreAtende,
        Multiselect,
        Documento, 
        CadastroItemTabela, 
        SolicitacaoAutorizLog, 
        AzInstrucoes,
        AutEquipeCirurgia,
        OrderSetView, 
        ClonarSolicitacaoAutoriz, 
        CadastrarNovoPaciente,
        PrintExport, 
        CabecalhoGenerico, 
        GuiaEdicao, 
        RegistrarContatos, 
        DocumentoPreAtendimento, 
        SolicitacaoAutorizacaoMaterial, 
    },

    computed: {
        lista_sessoes: function () { 
            if ( !this.marc_sessoes || !this.marc_sessoes.marcacoes ) { 
                return [];
            }

            if ( !this.marc_sessoes.separar ) { 
                return this.marc_sessoes.marcacoes;
            }

            let datas = this.$util.periodo_2_datas(this.filtros_sessoes);

            if ( !datas.inicio )
                return [];

            let inicio = datas.inicio;
            let fim = datas.fim + ' 23:59:59';
            // let reg = this.$util.getregex(this.filtros_sessoes.pesquisar);
            
            return this.marc_sessoes.marcacoes.filter(item => item.dt_inicio >= inicio && item.dt_inicio <= fim);

                /*
                .filter(item => {
                    return reg.test(JSON.stringify(item));
                });
                */
        },

        eh_sulamerica: function () { 
            return this.item   
                ? this.item.plano.operadora.st_registro_ans == '006246'
                : false;
        },

        eh_bradesco: function () { 
            return this.item   
                ? this.item.plano.operadora.st_registro_ans == '005711'
                : false;
        },

        lista_unidades: function () {
            // this.$store.state.unidade.unidade_operacaos
            return _.orderBy(
                this.$util.unidades_com_tags(true, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        exibicao: function () {
            if ( !this.dados )
                return [];

            //let pesquisar = this.filtros.pesquisar.trim();
            //let parts = pesquisar.replace(" ", ".*");
            //let match = parts;
            //let reg = new RegExp(match, "i");

            let reg = this.$util.getregex(this.filtros.pesquisar);
            let items;

            if (this.filtros.pesquisar) {
                items = this.dados.data.filter(item => {
                    return reg.test(JSON.stringify(item));
                });
            } else {
                items = this.dados.data;
            }

            return items;
        },

        valor_total_previa: function () { 
            if ( !this.item )
                return;

            const fator = ( this.item.dc_fator ? this.item.dc_fator : 1 );

            let valor = this.item.dc_valor_procedimento * this.item.in_quantidade * fator;

            if ( this.item.js_secundarios ) { 
                valor = valor + this.item.js_secundarios.reduce((total, carry) => { 
                    return total + parseFloat(carry.dc_valor_procedimento * carry.in_quantidade * fator);
                }, 0);
            }

            return valor;
        },

        lista_documentos: function () { 

            if ( !this.item || !this.item.pedido )
                return [];

            const tags = this.lista_doc_tags.filter(tag => tag.selec);

            return this.item.pedido.documentos.filter(doc => !tags.length 
                || ( doc.modelo_documento && _.intersection(doc.modelo_documento.js_classes, tags.map(tag => tag.tag)).length )
            );

        },
    },

    methods: {
        atualizar_qtde_item () { 
            if ( !this.qtde_editada ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Informe a quantidade.' 
                });
                return; 
            }

            if ( !( this.qtde_editada >= 1 && this.qtde_editada <= 200  ) ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Quantidade inválida: ' + this.qtde_editada
                });
                return; 
            }


            this.edicao_qtde_item.in_quantidade = this.qtde_editada;
            $('#editarQuantidadeItemModal').modal('hide');
        },

        editar_qtde (item) { 
            this.qtde_editada = item.in_quantidade;
            this.edicao_qtde_item = item;

            $('#editarQuantidadeItemModal').modal('show');
        },

        adicionar_marcacao(marcacao) {
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.$router.push({
                name: "call-center",
                params: { adicao: marcacao.id_marcacao },
            });
        },

        editar_contatos(solic) { 
            if ( this.lista_status === null ) { 
                this.$util.loadItem(this, { 
                    service: 'contato_status',
                    func: 'index',
                    parms: { 
                        lista: true,
                        model: 'solicitacaoAutorizacao',
                        ativos: true, 
                    }
                })
                .then(res => { 
                    this.lista_status = res;
                });
            }

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: { 
                    id: solic.id_solicitacao_autorizacao, 
                    contatos: true, 
                },
                loadTo: res => { 
                    this.edicao_contatos = _.cloneDeep(res);
                    this.edicao_contatos.model = { 
                        type: 'solicitacaoAutorizacao',
                        id: solic.id_solicitacao_autorizacao,
                    };
                    
                    this.$refs.regcontatos.editar(this.edicao_contatos);
                }
            });
            
        } ,

        salvar_alterar_solicitante () { 
            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'alterar_solicitante',
                dados: { 
                    id_solicitacao_autorizacao: this.item.id_solicitacao_autorizacao,
                    id_medico_solicitante: this.novo_solicitante ? this.novo_solicitante.id_medico_solicitante : null,
                },
                toast: true, 
                modal: 'alterarSolicitanteModal', 
                reload: true, 
            });
        },

        alterar_solicitante (solic) { 
            this.novo_solicitante = ""; 
            this.item = _.cloneDeep(solic);
            $('#alterarSolicitanteModal').modal('show');
        },

        ver_guia (guia) { 
            this.$refs.guia.abrir(guia);
        },

        retirar_pacote (item) { 
            item.js_pacote = null;
            this.$forceUpdate();
        },

        ver_pacotes (pacotes, index = null) {
            this.indexProcPacote = this.pacotes ? null : index;
            this.pacotes = this.pacotes ? null : pacotes;

            this.$forceUpdate();
        },

        selecionar_pacote(pacote, total = null, calculado = false, valor = null) {

            if ( pacote && pacote.pacote && pacote.pacote.fl_combo && pacote.pacote.fl_combo_pacote && !calculado ) {

                if ( pacote.pacote.fl_particular ) {
                    this.selecionar_pacote(pacote, total, true, pacote.pacote.dc_valor);
                }

                return;

            }

            if ( pacote.pacote.fl_qtde_variada && !total ) {
                this.sel_pacote = pacote;
                this.qtde_sessoes = pacote.in_quantidade;
                $('#qtdeSessaoModal').modal('show');
                return;
            } else if ( pacote.pacote.fl_qtde_variada && total ) {
                pacote.in_quantidade = total;
                $('#qtdeSessaoModal').modal('hide');
            } else if ( pacote.pacote.in_quantidade ) { 
                pacote.in_quantidade = pacote.pacote.in_quantidade;
            }

            // this.item.in_total_sessao = pacote.in_quantidade;
            
            if ( !valor ) {

                if ( this.item.plano.id_operadora == 1 && pacote.pacote.pacote_sessao_valores ) {
                    let sessao_valor = pacote.pacote.pacote_sessao_valores.find(psv => psv.id_plano == this.item.plano.id_plano);

                    if ( sessao_valor ) {
                        valor = sessao_valor.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 );
                    }
                }

            }

            if ( this.indexProcPacote === null ) { 

                this.$set(this.item, 'js_pacote', {
                    in_quantidade_items: total ? total : pacote.in_quantidade,
                    dc_valor_pacote: valor
                        ? valor
                        : (
                            this.item.plano.id_operadora == 1 
                                ? ( pacote.pacote.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 ) )
                                : this.item.dc_valor_procedimento * pacote.in_quantidade
                        ),
                    search: pacote.search ? pacote.search : pacote.pacote.search, 
                    id_pacote: pacote.id_pacote, 
                    id_procedimento_pacote: pacote.id_procedimento_pacote, 
                });

            } else { 

                this.$set(this.item.js_secundarios[this.indexProcPacote], 'js_pacote', {
                    in_quantidade_items: total,
                    dc_valor_pacote: valor
                        ? valor
                        : (
                            this.item.plano.id_operadora == 1 
                                ? ( pacote.pacote.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 ) )
                                : this.item.dc_valor_procedimento * pacote.in_quantidade
                        ),
                    search: pacote.search ? pacote.search : pacote.pacote.search, 
                    id_pacote: pacote.id_pacote, 
                    id_procedimento_pacote: pacote.id_procedimento_pacote, 
                });

            }

            this.pacotes = null;
            this.indexProcPacote = null;

            this.$forceUpdate();

            $('#qtdeSessaoModal').modal('hide');

        },

        //

        cadastrar_paciente (item) { 
            this.$refs.cadnovo.abrir(item);
        },
        
        clonar(solic) { 
            this.$refs.clone.abrir(solic);
        },

        confirmar_separacao() { 
            if ( !confirm('Confirma realizar a separação das marcações selecionadas para outro processo de autorização?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'separar',
                dados: { 
                    lista: this.lista_sessoes.filter(item => !item.id_atendimento && item.selec).map(item => item.id_marcacao)
                },
                toast: true, 
                modal: 'marcacaoSessaoModal', 
                reload: true, 
            });
        },

        marcar_sessoes() { 
            let selecao = this.lista_sessoes.find(item => !item.id_atendimento && !item.selec) ? true : false;

            this.lista_sessoes.forEach(item => { 
                item.selec = selecao;
            });
        },

        separar_autoriz(item) { 
            item.separar = !item.separar;

            this.$nextTick(() => { 
                this.$forceUpdate();
            });
        },

        incluir_membro_cirurgia (item = null) { 
            if ( !item ) { 

                if ( !this.item.js_equipe ) { 
                    this.item.js_equipe = { equipe: [] };
                }

                this.item.js_equipe.equipe.push({
                    id_grau_participacao: "",
                    id_medico: "", 
                    id_especialidade: "", 
                    dc_valor: null, 
                });

                this.$forceUpdate();

            }
        },

        integrar_solic_klingo (solic) { 
            if ( !confirm('Deseja integrar a solicitação de autorização?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'integrar_solic_klingo',
                dados: { 
                    id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao 
                },
                toast: true, 
                msg: 'Integração disparada com sucesso.',
            });
        },

        negar_sem_tabela(item) { 
            let cont = 0;

            item.js_secundarios.forEach(sec => { 
                if ( !item.info_procedimentos[sec.id_procedimento].st_codigo ) { 
                    sec.in_status = 3;
                    cont ++;
                } else if ( item.info_procedimentos[sec.id_procedimento].nao_cobre ) { 
                    sec.in_status = 3;
                    cont ++;
                }
            });

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: cont + " item(ns) marcado(s).",
                life: 4000
            });
        },

        gerar_orcamento (solic, gerar = false) { 
            if ( gerar ) { 

                if ( !solic.plano_orcamento ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Necessário informar o particular.",
                        life: 4000
                    });
                    return;
                }

                $('.modal').modal('hide');

                this.$nextTick(() => { 

                    this.$router.push(
                        {
                            name: 'orcamento', 
                            params: { 
                                origem: solic,
                            } 
                        }
                    );

                });

                return;

            }

            $('.modal').modal('hide');

            this.solic_para_orc = _.cloneDeep(solic);
            this.solic_para_orc.plano_orcamento = "";

            $('#gerarOrcamentoModal').modal('show');

        },

        log_comunicacao (solic) { 
            this.$refs.log_autoriz.abrir(solic.id_solicitacao_autorizacao);
        },

        definir_qtde(item, idx) { 
            item.in_quantidade = idx;
            this.$forceUpdate();
        },

        abrir_tabela (id) { 
            const contexto = {
                data: this.item.dt_solicitacao,
                cirurgia: false,
                emergencia: false,
            };

            this.$refs.cadastroitemtabela.exibir_moeda_corrente(
                { id_item_tabela: id }, 
                this.item.plano.operadora, 
                null, 
                contexto
            );
        },

        info_proc(id_procedimento) { 
            return this.item.info_procedimentos[id_procedimento];
        },

        novoDocumento(marcacao, solic) {
            let nome = _.get(solic, 'paciente.st_nome') 
                ? _.get(solic, 'paciente.st_nome') 
                : _.get(solic, 'cadastro_temporario.st_nome');

            if ( !marcacao ) { 
                marcacao = { id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao };
            }

            this.$refs.documento.novoDocumento(
                marcacao,
                { id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao },
                nome
            );
        },

        executar_agora (solic) { 
            if ( !confirm('Deseja executar o procedimento agora?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'executar_agora',
                dados: { 
                    id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao 
                },
                toast: true, 
                reload: true, 
            });
        },

        filtrar(classe) { 
            if ( this.filtros.pesquisar == '\x22' + classe + '\x22' ) { 
                this.filtros.pesquisar = ''
            } else { 
                this.filtros.pesquisar = '\x22' + classe + '\x22'
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        incluir_texto(item, texto) { 
            let incluido = false; 

            if ( texto && texto.js_classes ) { 
                let sinais = texto.js_classes.find(tag => tag == 'sinais');
                if ( sinais ) { 
                    incluido = true; 
                    item.st_observacoes = texto.texto_puro ? texto.texto_puro : texto.st_texto;    
                }

                let condicoes = texto.js_classes.find(tag => tag == 'condicoes');
                if ( condicoes ) { 
                    incluido = true; 
                    item.st_aih_just_int = texto.texto_puro ? texto.texto_puro : texto.st_texto;    
                }

                let resultados = texto.js_classes.find(tag => tag == 'resultados');
                if ( resultados ) { 
                    incluido = true; 
                    item.st_aih_just_res = texto.texto_puro ? texto.texto_puro : texto.st_texto;    
                }
            }

            if ( !incluido ) { 
                item.st_observacoes = texto.texto_puro ? texto.texto_puro : texto.st_texto;    
            }
        }, 

        lista_tags (item) { 
            if ( !item.pedido )
                return [];

            return _.uniq(
                item.pedido.documentos.filter(doc => doc.modelo_documento && doc.modelo_documento.js_classes)
                    .flatMap(doc => doc.modelo_documento.js_classes)
                    .sort()
            ).map(tag => { 
                return { 
                    tag: tag,
                    selec: false, 
                };
            });
        },

        remover_item (idx) { 
            this.item.js_secundarios.splice(idx, 1);
        },

        incluirProcedimento() { 
            if ( Array.isArray(this.novoProcedimento) ) { 
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( this.novoProcedimento && this.item ) { 
                if ( !this.item.js_secundarios )
                    this.item.js_secundarios = [];

                this.item.js_secundarios.push({ 
                    in_quantidade: 1, 
                    id_procedimento: this.novoProcedimento.id_procedimento,
                    st_procedimento: this.novoProcedimento.st_procedimento, 
                    st_codigo_cbhpm: this.novoProcedimento.st_codigo_cbhpm,  
                    st_codigo_sus: this.novoProcedimento.st_codigo_sus, 
                    search: this.novoProcedimento.search,
                    in_status: 0, 
                    n: true
                });

                if ( this.novoProcedimento.procedimento_pacotes && this.novoProcedimento.procedimento_pacotes.length ) { 

                    if ( !this.item.possiveis_pacotes ) { 
                        this.item.possiveis_pacotes = { lista: {} };
                    }

                    this.item.possiveis_pacotes.lista[this.novoProcedimento.id_procedimento] = _.cloneDeep(this.novoProcedimento);

                }

            }

            this.$nextTick(() => {
                this.novoProcedimento = "";
            });
        },

        abrir_recepcao(solic) { 
            let nome = solic.paciente 
                ? solic.paciente.st_nome
                : solic.cadastro_temporario.st_nome;

            this.$router.push(
                { 
                    name: 'recepcao', 
                    params: { 
                        parmdata: solic.marcacao.dt_inicio.substr(0,10),
                        nome: nome
                    } 
                }
            );
        },

        abrir_atendimento(solic) { 
            $('.modal').modal('hide');
            this.$util.abrir_atendimento(this, solic.marcacao.id_atendimento);
        },

        calcular_valor_direto(sec = null) { 
            let base = this.eh_sulamerica
                ? this.calc.valor
                : this.calc.qtd * this.calc.valor * this.calc.multiplo;

            this.calc.troca = true;

            this.$nextTick(() => { 
                if ( sec ) { 
                    sec.dc_valor_procedimento = Math.round ( base * 100 ) / 100;
                } else { 
                    this.item.dc_valor_procedimento = Math.round ( base * 100 ) / 100;
                }

                this.item.dc_fator = 1;
                this.calc.troca = false;
            });
        },

        calcular_fator() { 
            if ( this.eh_bradesco ) { 

                this.calc.troca = true;

                this.$nextTick(() => { 
                    if ( this.calc.tipo == 'C' ) { 
                        this.item.dc_fator = Math.round(this.calc.valor * this.calc.multiplo * 100000) / 100000;
                    } else { 
                        this.item.dc_fator = Math.round((this.calc.qtd ? this.calc.us / this.calc.qtd : 0) * 100000) / 100000
                    }

                    this.calc.troca = false;
                });
                
                return;
            }

            let base = this.eh_sulamerica
                ? this.calc.valor
                : this.calc.qtd * this.calc.valor * this.calc.multiplo;

            if ( this.calc.us > 0 ) { 
                this.calc.troca = true;

                this.$nextTick(() => { 
                    this.item.dc_fator = Math.round ( ( base / this.calc.us ) * 100 ) / 100;
                    this.calc.troca = false;
                });
            } else { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Necessário informar o valor da US.",
                    life: 4000
                });
                return;
            }
        },

        obter_credenciais_reembolso (item) { 
            this.$refs.cred.abrir(item);
        },
        calcular_valores (item) { 
            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes', 
                func: 'calcular_valores',
                dados: { 
                    ...item, 
                },
                toast: true, 
                callback: res => { 
                    this.aut_view = 'x';

                    this.$nextTick(() => { 
                        item.dc_valor_procedimento = _.get(res, 'valor.valor');

                        if ( res.secs && res.secs.length ) { 
                            res.secs.forEach((sec, key) => { 
                                if ( sec.valor && sec.valor.valor ) { 
                                    item.js_secundarios[key].dc_valor_procedimento = sec.valor.valor;
                                }
                            });
                        }

                        this.aut_view = 'val';

                        
                    });
                }
            });
        },

        definir_guia_sec(sec) { 
            if ( !sec.info_guia ) { 
                sec.info_guia = true;
                sec.st_guia_operadora = "";
                sec.st_guia_prestador = "";
            } else { 
                sec.info_guia = false;
            }

            this.$nextTick(() => { 
                this.$forceUpdate();
            });
        },
        fechar(modal) {
            $('#' + modal).modal('hide');
        },
        vincular_marcacao (item, outra, retirar = false, block_cancelar = false) {
            if ( this.$store.state.loading ) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Atualização em andamento...",
                    life: 3000
                });
                return;
            }

            if ( ( outra.id_atendimento || block_cancelar ) && retirar ) { 
                if ( !confirm('Confirma desvincular o atendimento #' + outra.id_atendimento + ' selecionada da autorização?') ) { 
                    return;
                }
            }

            this.$util.atualizar(this, {
                service: 'solicitacao_autorizacoes',
                func: 'vincular_marcacao',
                dados: {
                    id_solicitacao_autorizacao: item.id_solicitacao_autorizacao,
                    id_marcacao: outra.id_marcacao,
                    retirar: retirar,
                    block_cancelar: block_cancelar, 
                },
                modal: 'marcacaoSessaoModal',
                reload: true,
                toast: true,
            });
        },

        obter_marcacoes (item) {
            let parms = {};

            if ( item.id_paciente ) {
                parms.id_paciente = item.id_paciente;
            } else if ( item.id_cadastro_temporario ) {
                parms.id_cadastro_temporario = item.id_cadastro_temporario;
            }

            this.$util.load(this, {
                service: 'marcacoes',
                func: 'index',
                parms: {
                    ...parms,
                    id_procedimento: item.id_procedimento,
                    id_solicitacao_autorizacao: item.id_solicitacao_autorizacao, 
                    vincular_autorizacao: true,
                },
                loadTo: res => {
                    this.marc_sessoes.vincular = res;
                    this.$forceUpdate();
                },
            });
        },
        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        ver_sessoes (item) {
            item.separar = false;

            if ( item.marcacoes ) { 
                item.marcacoes.forEach(item => { 
                    item.selec = false;
                });
            }

            this.marc_sessoes = _.cloneDeep(item);

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: {
                    id: item.id_solicitacao_autorizacao, 
                    lista_marcacoes: true,
                },
                loadTo: res => {
                    this.marc_sessoes.marcacoes = res.marcacoes.map(item => { 
                        item.selec = false;
                        return item;
                    });

                    this.$forceUpdate();
                },
            })

            $('#marcacaoSessaoModal').modal('show');
        },

        exigir_senha(item, solic = null) {
            return ( item.in_status == 1 || item.in_status == 4 )
                && ( !this.item || !this.item.st_guia_prestador )
                && _.get(solic ? solic : item, 'plano.operadora.guia_operadora.st_versao_tiss', '03').substr(0,2) != '02';
        },

        imprimir_receita(dados) {
            if ( !dados )
                return;

            this.$util.print_preview('imprimir/receita/' + dados.id_receita, true, { ia: true }, true);
        },

        imprimir_requisicao(dados, modelo = null) {
            if ( !dados )
                return;
            
            if ((dados.st_modelo == '' || dados.st_modelo == null) && modelo == null) {
                modelo = 'tiss'; 
            }

            this.$util.print_preview('imprimir/requisicao/' + dados.id_requisicao, true, { modelo: modelo, ia: true }, true);
        },

        imprimir_documento(doc) {
            if ( !doc )
                return;

            this.$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true);
        },

        salvar_marcar_envio (envio = true) {
            this.$util.atualizar(this, {
                service: 'solicitacao_autorizacoes',
                func: 'marcar_envio',
                dados: {
                    id_solicitacao_autorizacao: this.item.id_solicitacao_autorizacao,
                    st_observacao_envio: this.item.st_observacao_envio,
                    data_envio: this.item.data_envio, 
                    envio: envio,
                },
                modal: 'solicAutEnvioModal',
                toast: true,
                reload: true,
            });
        },

        marcar_enviada(solic) {
            this.modal_tipo = 'envio';
            this.item = _.cloneDeep(solic);

            $('#solicAutEnvioModal').modal('show');
        },

        cor_linha(item) {
            let cor = '';

            switch (parseInt(item.in_status)) {
                case 1:
                case 9:
                case 10:
                    cor = 'alert-success';
                    break;
                case 2:
                    cor = 'alert-info';
                    break;
                case 3:
                    cor = 'alert-danger';
                    break;
                case 4:
                    cor = 'alert-warning';
                    break;
                case 5:
                    cor = 'alert-secondary';
                    break;
            }

            return cor;
        },

        copiar_senha(item) {
            if ( !confirm('Confirma copiar a autorização para os demais procedimentos?') )
                return;

            item.js_secundarios.forEach(sec => {
                sec.in_status = item.in_status;
                sec.st_codigo_autorizacao = item.st_codigo_autorizacao;
                sec.dt_validade_autorizacao = item.dt_validade_autorizacao;
                sec.dt_autorizacao = item.dt_autorizacao;
                sec.dt_valid_inicio = item.dt_valid_inicio;
                sec.dt_valid_termino = item.dt_valid_termino;
            });
        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        tem_autorizador (solic) {
            return solic.plano && solic.plano.operadora.id_areport_oper_service && solic.plano.operadora.fl_servico_autorizacao;
        },

        recalc_contrato_operadora () {
            this.$util.load(this, {
                service: 'solicitacao_autorizacoes',
                func: 'recalc_contrato',
                parms: {
                    id_solicitacao_autorizacao: this.item.id_solicitacao_autorizacao,
                },
                toast: true,
                loadTo: res => {
                    this.item.contrato_operadora = res;
                }
            });
        },

        copiar_clipboard (text) {
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else {
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Código '" + text + "' copiado para a área de transferência.",
                life: 3000
            });
        },

        novo_medico (item) {
            item.medico_solicitante = {
                id_medico_solicitante: null,
                st_nome: "",
                st_numero_conselho: "",
                id_conselho: "",
                id_estado_conselho: "",
                especialidade: "",
            };
        },

        setNomeMedico () {
            // this.item.medico_solicitante.st_nome = value;
        },

        remover(item) {
            if ( !confirm( 'Confirma o cancelamento da solicitação de autorização?') )
                return;

            this.$util.remover(this, {
                service: 'solicitacao_autorizacoes',
                dados: item,
                reload: true,
                modal: 'edicaoSolicModal',
            });
        },

        editar(item) {
            this.item = null;
            this.pacotes = null; 
            this.validate = false;
            this.lista_doc_tags = [];
            this.show_secs = false;
            this.modal_tipo = 'editar';

            this.$nextTick(() => {
                $('#edicaoSolicModal').modal('show');

                this.$util.load(this, {
                    service: 'solicitacao_autorizacoes',
                    func: 'index',
                    parms: {
                        id_solicitacao_autorizacao: item.id_solicitacao_autorizacao,
                        autorizar: true,
                    },
                    loadTo: res => {
                        if ( res[0].cadastro_temporario && !res[0].cadastro_temporario.endereco ) { 
                            res[0].cadastro_temporario.endereco = { 
                                cidade: {}, 
                            };
                        }
                        this.item = res[0];

                        this.lista_doc_tags = _.cloneDeep(this.lista_tags(this.item));
                    }
                });
            });
        },

        refresh_arquivos () { 
            if ( this.item_arq && this.item_arq.arquivos ) { 
                this.$store.commit('loading', false);
                this.carregar_arquivos(this.item_arq, this.item_arq.id, this.item_arq.model);
            }
        },

        carregar_arquivos (item, id, model, abrir = false) { 

            if ( this.$store.state.loading )
                return;

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: id, 
                    type: model,
                }
            })
            .then(res => { 
                item.arquivos = res;
                item.model = model;
                item.id = id;

                if ( abrir ) {
                    this.acao_anexar = false;

                    this.$nextTick(() => {
                        this.item_arq = item;
                        this.acao_anexar = true;

                        // console.log(this.item_arq);

                        this.$nextTick(() => { 
                            this.$refs.upload.abrir();
                        });
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

        abrir_anexar_arquivo(item, id = null, model = null) {
            if ( !model ) { 

                if ( item.id_solicitacao_autorizacao ) { 
                    model = 'solicitacaoAutorizacao';
                    id = item.id_solicitacao_autorizacao;
                } else if ( item.id_paciente ) { 
                    model = 'pessoa';
                    id = item.id_paciente;
                } else if ( item.id_pessoa ) { 
                    model = 'pessoa';
                    id = item.id_pessoa;
                } else if ( item.id_cadastro_temporario ) { 
                    model = 'cadastroTemporario';
                    id = item.id_cadastro_temporario;
                }

            }

            if ( item.arquivos && item.arquivos.length && !item.arquivos.find(arq => arq.arquivo) ) { 
                this.carregar_arquivos(item, id, model, true);
                return;
            }

            item.model = model;
            item.id = id;

            this.acao_anexar = false;

            this.$nextTick(() => {

                this.item_arq = item;
                this.acao_anexar = true;

                this.$nextTick(() => {
                    this.$refs.upload.abrir();
                });

            });
        },

        agendar(item, medico = null, force_agenda = false, force_incluir = false) {
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            if ( item.procedimento.id_classe_procedimento == 2 
                && !force_incluir
                && this.$store.state.user.perfil_usuarios.find(perfil => perfil.id_perfil == 2 || perfil.id_perfil == 24) ) { 

                if ( medico === null ) { 
                    item.cc = true; 
                    item.outro_medico = "";

                    let dados = _.cloneDeep(item);

                    dados.item = _.cloneDeep(item);
                    dados.acao = 'A';
                    dados.data = this.$util.hoje();
                    dados.hora = this.$util.agora().substr(0,5);

                    this.agenda = dados;
                    
                    $('#agendarMedicoModal').modal('show');
                    return; 
                }

                // Agendar pelo Centro Cirúrgico...

                this.$nextTick(() => {
                    this.$router.push({
                        name: "centro-cirurgico",
                        params: { 
                            aba: 'marcacao', 
                            autorizacao: item.id_solicitacao_autorizacao,
                            outro_medico_selecionado: this.agenda.outro_medico, 
                        }
                    });
                });

                return;

            }

            this.$util.loadItem(this, { 
                service: 'configuracoes',
                func: 'index',
                parms: {
                    where: {
                        st_slug: 'atender-proc-sem-agenda',
                        fl_ativo: '1',
                    }
                }
            })
            .then(res => { 
                if ( res.length && res[0].st_valor > 0 && !force_agenda && !this.block_incluir_direto ) { 

                    this.agenda = { 
                        item: _.cloneDeep(item),
                        data: this.$util.hoje(),
                        hora: this.$util.agora().substr(0,5),
                    };
                    
                    this.$nextTick(() => {
                        $('#marcacaoDiretoModal').modal('show');
                        // $('#agendarMedicoModal').modal('show');
                    });

                } else { 

                    if ( medico === null ) { 
                        let dados = _.cloneDeep(item);

                        dados.item = _.cloneDeep(item);
                        dados.acao = 'A';
                        dados.data = this.$util.hoje();
                        dados.hora = this.$util.agora().substr(0,5);

                        this.agenda = dados;
                        
                        $('#agendarMedicoModal').modal('show');
                        return; 
                    }

                    this.$nextTick(() => {
                        this.$router.push({
                            name: "call-center",
                            params: { 
                                autorizacao: item.id_solicitacao_autorizacao, 
                                outro_medico: this.medico_agendar == 'Q' ? true : false, 
                                outro_medico_selecionado: this.medico_agendar == 'Q' ? this.agenda.outro_medico : null,
                            }
                        });
                    });

                }
            })

            
        },

        salvar_agenda () { 

            let medico = _.cloneDeep(this.agenda.item.medico);

            if ( this.medico_agendar == 'Q' && this.agenda.outro_medico ) { 
                medico = _.cloneDeep(this.agenda.outro_medico);
            }

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show',
                parms: { 
                    id: this.agenda.item.id_solicitacao_autorizacao,
                    para_agendar: true, 
                },
                loadTo: res => { 
                
                    let info = { 
                        procedimentos: [ 
                            { 
                                procedimento: _.cloneDeep(this.agenda.item.procedimento),
                                medico: medico,
                                plano: _.cloneDeep(this.agenda.item.plano),
                                data: this.agenda.data, 
                                hora: this.agenda.hora,
                                extra: false, 
                                ordem_chegada: true, 
                                remarcacao: null,
                                id_unidade_operacao: this.agenda.item.id_unidade_operacao,
                                id_agenda: null,
                                outros_procedimentos: this.agenda.item.js_secundarios,
                                combo: this.agenda.item.combo, 
                                id_solicitacao_autorizacao: this.agenda.item.id_solicitacao_autorizacao,
                            },
                        ],
                        fl_tele_atendimento: false,
                        inicio: '00:00',
                        termino: '00:00',
                        remarcacao: null,
                        autorizacao: this.agenda.item.id_solicitacao_autorizacao,
                        lista_de_espera: false,
                        origem: 'solicaut',
                    };

                    if ( res.id_paciente ) { 
                        info.paciente = _.cloneDeep(res.paciente);
                    } else { 
                        info.cadastro_temporario = _.cloneDeep(res.cadastro_temporario);
                    }

                    /*
                    if ( this.agenda.item.id_paciente ) { 
                        info.paciente = _.cloneDeep(this.agenda.item.paciente);
                    } else { 
                        info.cadastro_temporario = _.cloneDeep(this.agenda.item.cadastro_temporario);
                    }
                    */

                    this.$util.atualizar(this, { 
                        service: 'agendas',
                        func: 'store',
                        dados: info,
                        modal: 'marcacaoDiretoModal',
                        reload: true, 
                        callback: () => { 
                            $('.modal').modal('hide');
                        }
                    });

                }
                
            });
        },

        imprimir(item) {
            if ( item.fl_apac ) { 
                this.$util.print_preview('imprimir/solic_autoriz/' + item.id_solicitacao_autorizacao);
            } else { 
                this.$util.print_preview('imprimir/espelho_autorizacao/' + item.id_solicitacao_autorizacao);
            }
        },

        assinar_lea(item) {
            this.chave_lea = null;
            this.solicitacao_lea = null;
            this.solicitacao_lea = item;

            const chaveMedico = _.first(this.chaves_medicos.filter(c => c.id_medico == this.solicitacao_lea.id_medico));
            if(chaveMedico != null) {
                this.chave_lea = chaveMedico.chave;
            }

            $('#assinarModal').modal('show');
        },

        atualizar_assinar_lea() {
            if(this.chave_lea == null) {
                 this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Informa Senha/Chave do certificado',
                    life: 3000
                });
                return;
            }

            $('#assinarModal').modal('hide');

            this.axios
                .post(
                    'imprimir/assinar_lea/' + this.solicitacao_lea.id_solicitacao_autorizacao,
                    {
                        chave: this.chave_lea
                    },
                )
                .then(res => {
                    if(res && res.data && res.data.status_code && res.data.status_code >= 400) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.data.msg ? res.data.msg : 'Erro ao assinar LEA',
                            life: 3000
                        });
                        return;
                    }

                    const chaveMedico = _.first(this.chaves_medicos.filter(item => item.id_medico == this.solicitacao_lea.id_medico));
                    if(chaveMedico == null) {
                        this.chaves_medicos.push({ id_medico: this.solicitacao_lea.id_medico, chave: this.chave_lea});
                    } else {
                        this.chaves_medicos.splice(this.chaves_medicos.findIndex(item => item.id_medico === this.solicitacao_lea.id_medico), 1);
                        this.chaves_medicos.push({ id_medico: this.solicitacao_lea.id_medico, chave: this.chave_lea});
                    }

                     this.$toast.add({
                        severity: "success",
                        summary: "Lea assinada",
                        detail: 'Lea assinada com successo e anexada a solicitação.',
                        life: 3000
                    });
                    this.load();
                });
        },

        fechar_assinar_lea() {
            $('#assinarModal').modal('hide');
        },

        autorizar(item) {
            this.validate = false;
            this.item = null;
            this.pacotes = null;
            this.modal_tipo = 'autorizar';
            this.calc.qtd = 0;
            this.calc.valor = 0;
            this.calc.multiplo = 1;
            this.calc.us = 0;
            this.calc.troca = false;

            if ( this.$refs.instruc_aut ) { 
                this.$refs.instruc_aut.reset();
            }
                
            this.$nextTick(() => { 
                $('#autorizarModal').modal('show');

                this.$util.load(this, {
                    service: 'solicitacao_autorizacoes',
                    func: 'index',
                    parms: {
                        id_solicitacao_autorizacao: item.id_solicitacao_autorizacao,
                        autorizar: true,
                    },
                    loadTo: res => {
                        let temp = _.cloneDeep(res[0]);

                        if ( _.get(temp, 'marcacao.infusao.protocolo.receita') ) { 
                            temp.marcacao.infusao.protocolo.receita.hide = true;
                        }
    
                        if ( !temp.st_codigo_autorizacao && temp.in_status != 1 ) {
                            temp.dt_autorizacao = this.$util.hoje();
                            temp.dt_valid_inicio = this.$util.hoje();
                            temp.dt_valid_termino = ( temp.fl_apac
                                ? moment(temp.dt_valid_inicio, "YYYY-MM-DD")
                                    .add(2, "months")
                                    .endOf('month')
                                    .format('YYYY-MM-DD')
                                : "" );
                        }
            
                        if ( !temp.js_secundarios ) {
                            temp.js_secundarios = [];
                        }
            
                        temp.js_secundarios = temp.js_secundarios.map(sec => {
                            sec.in_status = sec.in_status ? sec.in_status : '';
                            return sec;
                        });
            
                        this.item = temp;

                        this.$nextTick(() => { 
                            this.$refs.instruc_aut.buscar_plano(item);
                        });

                    }
                });
            
            });

        },

        autorizar_save() {
            if ( this.item.contrato_operadora && this.item.contrato_operadora.fl_reembolso ) { 
                if ( ( this.item.in_status == 1 || this.item.in_status == 4 ) && !this.item.dt_valid_termino ) { 
                    this.item.dt_valid_termino = moment(this.item.dt_valid_inicio).add(90, 'days').format('YYYY-MM-DD');
                }

                this.item.js_secundarios.forEach(sec => { 
                    if ( ( sec.in_status == 1 || sec.in_status == 4 ) && !sec.dt_valid_termino ) { 
                        sec.dt_valid_termino = moment(sec.dt_valid_inicio).add(90, 'days').format('YYYY-MM-DD');
                    }   
                });
            }

            this.$util.atualizar(this, {
                service: "solicitacao_autorizacoes",
                dados: this.item,
                modal: 'autorizarModal',
                reload: true,
            });
        },

        log_autorizacoes(solic) {
            this.logAutorizacoesSelecionado = null;
            this.logAutorizacoes = null;

            this.$util.atualizar(this, {
                service: "solicitacao_autorizacoes",
                func: "log_autorizacoes",
                dados: {
                    id_solicitacao_autorizacao: solic
                    ? solic.id_solicitacao_autorizacao
                    : null,
                },
                callback: res => {
                    this.logAutorizacoes = res.solicitacao_autorizacao_log;
                    $('#autorizLogModal').modal('show');
                }
            });

        },

        autorizar_online(solic) {
            this.$refs.autoriz.autorizar_solicitacao(solic);
        },
        consultar_online(solic) {
          if (confirm("Deseja realmente consultar a autorização Online?")) {
            this.$util.atualizar(this, {
                  service: 'solicitacao_autorizacoes',
                  func: 'status_autorizacao',
                  redir_api: true,
                  dados: {
                      id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
                  },
                  reload: true,
                  callback: (res) => {
                     this.$toast.add({
                        severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                        summary: "Atenção",
                        detail: res.msg,
                        life: 3000
                    });
                  }
              });
          }
        },
        enviar_documentos(solic) {
          if (confirm("Deseja enviar os documentos para a autorização online?")) {
            this.$util.atualizar(this, {
                  service: 'solicitacao_autorizacoes',
                  func: 'enviar_documentos',
                  redir_api: true,
                  dados: {
                      id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
                  },
                  reload: true,
                  callback: (res) => {
                     this.$toast.add({
                        severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                        summary: "Atenção",
                        detail: res.msg,
                        life: 3000
                    });
                  }
              });
          }
        },
        cancelar_online(solic) {
          if (confirm("Deseja cancelar a autorização online?")) {
            this.$util.atualizar(this, {
                  service: 'solicitacao_autorizacoes',
                  func: 'cancelamento_autorizacao',
                  redir_api: true,
                  dados: {
                      id_solicitacao_autorizacao: solic.id_solicitacao_autorizacao,
                  },
                  reload: true,
                  callback: (res) => {
                     this.$toast.add({
                        severity: (res.status_code && res.status_code == 200) ? "success" : "error",
                        summary: "Atenção",
                        detail: res.msg,
                        life: 3000
                    });
                  }
            });
          }
        },

        save(modal) {
            this.$util.atualizar(this, {
                service: "solicitacao_autorizacoes",
                dados: this.item,
                modal: modal,
                reload: true,
            });
        },

        incluir() {
            this.$refs.novasolic.reiniciar();
            $('#novaSolicitacaoModal').modal('show');
        },

        load(pagina = null) {
            if ( this.montando )
                return;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            if ( pagina ) { 
                this.page = pagina;
            }

            this.$util.setCookie('sol-aut-fila', this.filtros.id_fila_autorizacao);

            this.canceltoken = this.axios.CancelToken.source();

            this.ja_buscou = true;

            this.$util.load(this, {
                service: "solicitacao_autorizacoes",
                func: "index",
                canceltoken: this.canceltoken.token,
                parms: {
                    ...this.filtros,
                    pacotes: true,
                    page: this.page,
                    size: 100,
                },
                reload_page: true, 
                configs: [
                    'solic-aut-block-incluir-agenda-direto', 
                ],
                loadTo: res => {
                    this.block_incluir_direto = !!this.$store.state.contexto['solic-aut-block-incluir-agenda-direto'];

                    this.dados = res;

                    this.options_classes = _.uniq(
                        this.dados.data.filter(item => item.js_classes && item.js_classes.length)
                                .flatMap(item => item.js_classes)
                                .sort()
                    );
                }
            });
        }
    },

    beforeMount () {
        this.filtros.from = moment().subtract(30, "days").format('YYYY-MM-DD');
        this.filtros.to = moment().format('YYYY-MM-DD');

        if ( this.$route.params && this.$route.params.id ) {
            this.filtros.pesquisar = '#' + this.$route.params.id;
        }
    },

    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Autorizações", path: "/autorizacoes/lista" },
        ]);

        this.$nextTick(() => {
            this.montando = false;
            
            if ( this.filtros.pesquisar ) { 
                this.load();
            }
        });        
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>